export const bundleData: any = {
    // ca: [
    //     // 真实数据
    //     // WAVE 2 Portable Air Conditioner
    //     {
    //         id: '7780993138842',
    //         variantId: '43544558370970',
    //         type: 2, //1 早鸟+常规阶段（按时间线划分） 2 早鸟+常规阶段（按实时库存划分） 3 只有常规售卖阶段
    //         stage: 1, // 1 第一个倒计时阶段 2 第二个倒计时阶段
    //         off: '',
    //         offTips: '',
    //         name: 'WAVE 2 Portable Air Conditioner',
    //         tag: 2,
    //         isEnd: false,
    //         img: '/media/wave2/crowdfunding/pc/1.png',
    //         mobileImg: '/media/wave2/crowdfunding/h5/1.png',
    //         include: ['WAVE 2 Portable Air Conditioner x 1'],
    //         delivery_date: '',
    //         sale: 0,
    //         count: 50,
    //         discountPrice: 1199,
    //         originalPrice: 1599,
    //         price_suffix: '',
    //         sku: 'ZYDKT210-US',
    //         node: 'product-component-1683727272726',
    //         buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
    //     },
    //     {
    //         id: '7809759543450',
    //         variantId: '43552717373594',
    //         type: 2,
    //         stage: 2, // 1 第一个倒计时阶段 2 第二个倒计时阶段
    //         off: '',
    //         offTips: '',
    //         name: 'WAVE 2 Portable Air Conditioner',
    //         tag: null,
    //         isEnd: false,
    //         img: '/media/wave2/crowdfunding/pc/1.png',
    //         mobileImg: '/media/wave2/crowdfunding/h5/1.png',
    //         include: ['WAVE 2 Portable Air Conditioner x 1'],
    //         delivery_date: '',
    //         sale: 0,
    //         count: null,
    //         countdown: true, // 2023-05-24 卖不动、为刺激消费， @陈琨 要求添加倒计时，以加强紧迫感
    //         discountPrice: 1399,
    //         originalPrice: 1599,
    //         price_suffix: '',
    //         sku: 'ZYDKT210-US',
    //         node: 'product-component-1683727391099',
    //         buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-super-early-bird',
    //     },

    //     // WAVE 2 Portable Air Conditioner + WAVE 2 Add-on Battery
    //     {
    //         id: '7780993138842',
    //         variantId: '43544558403738',
    //         type: 2, //1 时间限定 2 数量限定
    //         stage: 1, // 1 第一个倒计时阶段 2 第二个倒计时阶段
    //         off: '',
    //         offTips: '',
    //         name: 'WAVE 2 Portable Air Conditioner + WAVE 2 Add-on Battery',
    //         tag: 2,
    //         isEnd: false,
    //         img: '/media/wave2/crowdfunding/pc/2.png',
    //         mobileImg: '/media/wave2/crowdfunding/h5/2.png',
    //         include: ['WAVE 2 Portable Air Conditioner x 1', 'WAVE 2 Add-on Battery x 1'],
    //         delivery_date: '',
    //         sale: 0,
    //         count: 50,
    //         discountPrice: 2099,
    //         originalPrice: 2799,
    //         price_suffix: '',
    //         sku: 'WAVE2-EB',
    //         node: 'product-component-1683727307846',
    //         buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
    //     },
    //     {
    //         id: '7809759543450',
    //         variantId: '43552717406362',
    //         type: 2,
    //         stage: 2, // 1 第一个倒计时阶段 2 第二个倒计时阶段
    //         off: '',
    //         offTips: '',
    //         name: 'WAVE 2 Portable Air Conditioner + WAVE 2 Add-on Battery',
    //         tag: null,
    //         isEnd: false,
    //         img: '/media/wave2/crowdfunding/pc/2.png',
    //         mobileImg: '/media/wave2/crowdfunding/h5/2.png',
    //         include: ['WAVE 2 Portable Air Conditioner x 1', 'WAVE 2 Add-on Battery x 1'],
    //         delivery_date: '',
    //         sale: 0,
    //         count: null,
    //         countdown: true, // 2023-05-24 卖不动、为刺激消费， @陈琨 要求添加倒计时，以加强紧迫感
    //         discountPrice: 2659,
    //         originalPrice: 2799,
    //         price_suffix: '',
    //         sku: 'WAVE2-EB',
    //         node: 'product-component-1683727420265',
    //         buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-super-early-bird',
    //     },

    //     // WAVE 2 Portable Air Conditioner + DELTA Max 2000
    //     {
    //         id: '7780993138842',
    //         variantId: '43552708362394',
    //         type: 2, //1 时间限定 2 数量限定
    //         stage: 1, // 1 第一个倒计时阶段 2 第二个倒计时阶段
    //         off: '',
    //         offTips: '',
    //         name: 'WAVE 2 Portable Air Conditioner + DELTA Max 2000',
    //         tag: 2,
    //         isEnd: false,
    //         img: '/media/wave2/crowdfunding/pc/4_us.png',
    //         mobileImg: '/media/wave2/crowdfunding/h5/4_us.png',
    //         include: ['WAVE 2 Portable Air Conditioner x 1', 'DELTA Max 2000x 1', 'XT150 Cable-1m(connects WAVE 2 to DELTA Max 2000) x 1'],
    //         delivery_date: '',
    //         sale: 0,
    //         count: 50,
    //         discountPrice: 3099,
    //         originalPrice: 4199,
    //         price_suffix: '',
    //         sku: '6900906721353',
    //         node: 'product-component-1683727330580',
    //         buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
    //     },
    //     {
    //         id: '7809759543450',
    //         variantId: '43552717439130',
    //         type: 2,
    //         stage: 2, // 1 第一个倒计时阶段 2 第二个倒计时阶段
    //         off: '',
    //         offTips: '',
    //         name: 'WAVE 2 Portable Air Conditioner + DELTA Max 2000',
    //         tag: null,
    //         isEnd: false,
    //         img: '/media/wave2/crowdfunding/pc/4_us.png',
    //         mobileImg: '/media/wave2/crowdfunding/h5/4_us.png',
    //         include: ['WAVE 2 Portable Air Conditioner x 1', 'DELTA Max 2000x 1', 'XT150 Cable-1m(connects WAVE 2 to DELTA Max 2000) x 1'],
    //         delivery_date: '',
    //         sale: 0,
    //         count: null,
    //         countdown: true, // 2023-05-24 卖不动、为刺激消费， @陈琨 要求添加倒计
    //         discountPrice: 3599,
    //         originalPrice: 4199,
    //         price_suffix: '',
    //         sku: '6900906721353',
    //         node: 'product-component-1683727456552',
    //         buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-super-early-bird',
    //     },

    //     // WAVE 2 Portable Air Conditioner + DELTA Pro
    //     {
    //         id: '7780993138842',
    //         variantId: '43552708427930',
    //         type: 2, //1 时间限定 2 数量限定
    //         stage: 1, // 1 第一个倒计时阶段 2 第二个倒计时阶段
    //         off: '',
    //         offTips: '',
    //         name: 'WAVE 2 Portable Air Conditioner + DELTA Pro',
    //         tag: 2,
    //         isEnd: false,
    //         img: '/media/wave2/crowdfunding/pc/3_us.png',
    //         mobileImg: '/media/wave2/crowdfunding/h5/3_us.png',
    //         include: ['WAVE 2 Portable Air Conditioner x 1', 'DELTA Pro x 1', 'XT150 Cable-1m(connects WAVE 2 to DELTA Pro) x 1', 'DELTA Pro Adapter x 1'],
    //         delivery_date: '',
    //         sale: 0,
    //         count: 50,
    //         discountPrice: 4699,
    //         originalPrice: 6099,
    //         price_suffix: '',
    //         sku: '6900906721353',
    //         node: 'product-component-1683727354664',
    //         buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
    //     },
    //     {
    //         id: '7809759543450',
    //         variantId: '43552717471898',
    //         type: 2,
    //         stage: 2, // 1 第一个倒计时阶段 2 第二个倒计时阶段
    //         off: '',
    //         offTips: '',
    //         name: 'WAVE 2 Portable Air Conditioner + DELTA Pro',
    //         tag: null,
    //         isEnd: false,
    //         img: '/media/wave2/crowdfunding/pc/3_us.png',
    //         mobileImg: '/media/wave2/crowdfunding/h5/3_us.png',
    //         include: ['WAVE 2 Portable Air Conditioner x 1', 'DELTA Pro x 1', 'XT150 Cable-1m(connects WAVE 2 to DELTA Pro) x 1', 'DELTA Pro Adapter x 1'],
    //         delivery_date: '',
    //         sale: 0,
    //         count: null,
    //         countdown: true, // 2023-05-24 卖不动、为刺激消费， @陈琨 要求添加倒计
    //         discountPrice: 5499,
    //         originalPrice: 6099,
    //         price_suffix: '',
    //         sku: '6900906721353',
    //         node: 'product-component-1683727476615',
    //         buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-super-early-bird',
    //     },
    // ],
    // us: [
    //     // 真实数据
    //     // WAVE 2 Portable Air Conditioner
    //     {
    //         id: '6904870568009',
    //         variantId: '40537176965193',
    //         type: 2, //1 时间限定 2 数量限定 3 只有一个常规售卖阶段
    //         stage: 1, // 1 第一个倒计时阶段 2 第二个倒计时阶段
    //         off: '',
    //         offTips: '',
    //         name: 'WAVE 2 Portable Air Conditioner',
    //         tag: 2,
    //         isEnd: false,
    //         img: '/media/wave2/crowdfunding/pc/1.png',
    //         mobileImg: '/media/wave2/crowdfunding/h5/1.png',
    //         include: ['WAVE 2 Portable Air Conditioner x 1'],
    //         delivery_date: '',
    //         sale: 0,
    //         count: 400,
    //         realCount: 1000, // 0515 老板希望卖2000个，shipify那边也是真实的2000个，但是运营希望促销前端官网只展示400个 @陈琨
    //         discountPrice: 999,
    //         originalPrice: 1299,
    //         price_suffix: '',
    //         sku: 'ZYDKT210-US',
    //         node: 'product-component-1683726881201',
    //         buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
    //     },
    //     {
    //         id: '6904755617865',
    //         variantId: '40536746229833',
    //         type: 2,
    //         stage: 2, // 1 第一个倒计时阶段 2 第二个倒计时阶段
    //         off: '',
    //         offTips: '',
    //         name: 'WAVE 2 Portable Air Conditioner',
    //         tag: null,
    //         isEnd: false,
    //         img: '/media/wave2/crowdfunding/pc/1.png',
    //         mobileImg: '/media/wave2/crowdfunding/h5/1.png',
    //         include: ['WAVE 2 Portable Air Conditioner x 1'],
    //         delivery_date: '',
    //         sale: 0,
    //         count: null,
    //         countdown: true, // 2023-05-24 卖不动、为刺激消费， @陈琨 要求添加倒计
    //         discountPrice: 1099, // 0515 17:00 @陈琨 @吉瑞轩 要求改价格
    //         originalPrice: 1299,
    //         price_suffix: '',
    //         sku: 'ZYDKT210-US',
    //         node: 'product-component-1683727084695',
    //         buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-super-early-bird',
    //     },

    //     // WAVE 2 Portable Air Conditioner + WAVE 2 Add-on Battery
    //     {
    //         id: '6904870568009',
    //         variantId: '40537176997961',
    //         type: 2, //1 时间限定 2 数量限定
    //         stage: 1, // 1 第一个倒计时阶段 2 第二个倒计时阶段
    //         off: '',
    //         offTips: '',
    //         name: 'WAVE 2 Portable Air Conditioner + WAVE 2 Add-on Battery',
    //         tag: 2,
    //         isEnd: false,
    //         img: '/media/wave2/crowdfunding/pc/2.png',
    //         mobileImg: '/media/wave2/crowdfunding/h5/2.png',
    //         include: ['WAVE 2 Portable Air Conditioner x 1', 'WAVE 2 Add-on Battery x 1'],
    //         delivery_date: '',
    //         sale: 0,
    //         count: 400,
    //         realCount: 1000, // 0515 老板希望卖2000个，shipify那边也是真实的2000个，但是运营希望促销前端官网只展示400个 @陈琨
    //         discountPrice: 1599,
    //         originalPrice: 2199,
    //         price_suffix: '',
    //         sku: 'WAVE2-EB',
    //         node: 'product-component-1683726918267',
    //         buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
    //     },
    //     {
    //         id: '6904755617865',
    //         variantId: '40536746262601',
    //         type: 2,
    //         stage: 2, // 1 第一个倒计时阶段 2 第二个倒计时阶段
    //         off: '',
    //         offTips: '',
    //         name: 'WAVE 2 Portable Air Conditioner + WAVE 2 Add-on Battery',
    //         tag: null,
    //         isEnd: false,
    //         img: '/media/wave2/crowdfunding/pc/2.png',
    //         mobileImg: '/media/wave2/crowdfunding/h5/2.png',
    //         include: ['WAVE 2 Portable Air Conditioner x 1', 'WAVE 2 Add-on Battery x 1'],
    //         delivery_date: '',
    //         sale: 0,
    //         count: null,
    //         countdown: true, // 2023-05-24 卖不动、为刺激消费， @陈琨 要求添加倒计
    //         discountPrice: 1799, // 0522 @陈琨 改价格
    //         originalPrice: 2199,
    //         price_suffix: '',
    //         sku: 'WAVE2-EB',
    //         node: 'product-component-1683727128046',
    //         buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-super-early-bird',
    //     },

    //     // WAVE 2 Portable Air Conditioner + DELTA Max 2000
    //     {
    //         id: '6904870568009',
    //         variantId: '40537177030729',
    //         type: 2, //1 时间限定 2 数量限定
    //         stage: 1, // 1 第一个倒计时阶段 2 第二个倒计时阶段
    //         off: '',
    //         offTips: '',
    //         name: 'WAVE 2 Portable Air Conditioner + DELTA Max 2000',
    //         tag: 2,
    //         isEnd: false,
    //         img: '/media/wave2/crowdfunding/pc/4_us.png',
    //         mobileImg: '/media/wave2/crowdfunding/h5/4_us.png',
    //         include: ['WAVE 2 Portable Air Conditioner x 1', 'DELTA Max 2000x 1', 'XT150 Cable-1m(connects WAVE 2 to DELTA Max 2000) x 1'],
    //         delivery_date: '',
    //         sale: 0,
    //         count: 400,
    //         discountPrice: 2499,
    //         originalPrice: 3399,
    //         price_suffix: '',
    //         sku: '6900906721353',
    //         node: 'product-component-1683726965339',
    //         buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
    //     },
    //     {
    //         id: '6904755617865',
    //         variantId: '40536746295369',
    //         type: 2,
    //         stage: 2, // 1 第一个倒计时阶段 2 第二个倒计时阶段
    //         off: '',
    //         offTips: '',
    //         name: 'WAVE 2 Portable Air Conditioner + DELTA Max 2000',
    //         tag: null,
    //         isEnd: false,
    //         img: '/media/wave2/crowdfunding/pc/4_us.png',
    //         mobileImg: '/media/wave2/crowdfunding/h5/4_us.png',
    //         include: ['WAVE 2 Portable Air Conditioner x 1', 'DELTA Max 2000x 1', 'XT150 Cable-1m(connects WAVE 2 to DELTA Max 2000) x 1'],
    //         delivery_date: '',
    //         sale: 0,
    //         count: null,
    //         countdown: true, // 2023-05-24 卖不动、为刺激消费， @陈琨 要求添加倒计
    //         discountPrice: 2799,
    //         originalPrice: 3399,
    //         price_suffix: '',
    //         sku: '6900906721353',
    //         node: 'product-component-1683727157718',
    //         buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-super-early-bird',
    //     },

    //     // 2023-04-28 新增
    //     // WAVE 2 Portable Air Conditioner + GLACIER Portable Refrigerator
    //     {
    //         id: '6904870568009',
    //         variantId: '40537177063497',
    //         type: 2, //1 时间限定 2 数量限定
    //         stage: 1, // 1 第一个倒计时阶段 2 第二个倒计时阶段
    //         off: '',
    //         offTips: '',
    //         name: 'WAVE 2 Portable Air Conditioner + GLACIER Portable Refrigerator',
    //         tag: 2,
    //         isEnd: false,
    //         img: '/media/wave2/crowdfunding/pc/5.png',
    //         mobileImg: '/media/wave2/crowdfunding/h5/5.png',
    //         include: ['WAVE 2 Portable Air Conditioner  x 1', 'GLACIER Portable Refrigerator x 1', '*Wheels and lever are not included'],
    //         hasNote: true,
    //         delivery_date: '',
    //         sale: 0,
    //         count: 200,
    //         discountPrice: 1899,
    //         originalPrice: 2399,
    //         price_suffix: '',
    //         sku: '6900906721353',
    //         node: 'product-component-1683726993388',
    //         buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
    //     },
    //     {
    //         id: '6904755617865',
    //         variantId: '40536746328137',
    //         type: 2,
    //         stage: 2, // 1 第一个倒计时阶段 2 第二个倒计时阶段
    //         off: '',
    //         offTips: '',
    //         name: 'WAVE 2 Portable Air Conditioner + GLACIER Portable Refrigerator',
    //         tag: null,
    //         isEnd: false,
    //         img: '/media/wave2/crowdfunding/pc/5.png',
    //         mobileImg: '/media/wave2/crowdfunding/h5/5.png',
    //         include: ['WAVE 2 Portable Air Conditioner  x 1', 'GLACIER Portable Refrigerator x 1', '*Wheels and lever are not included'],
    //         hasNote: true, // 最后一个include项是个无轮子无拉杆提示语 - 特殊样式
    //         delivery_date: '',
    //         sale: 0,
    //         count: null,
    //         countdown: true, // 2023-05-24 卖不动、为刺激消费， @陈琨 要求添加倒计
    //         discountPrice: 2199,
    //         originalPrice: 2399,
    //         price_suffix: '',
    //         sku: '6900906721353',
    //         node: 'product-component-1683727198022',
    //         buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-super-early-bird',
    //     },

    //     // WAVE 2 Portable Air Conditioner + DELTA Pro
    //     {
    //         id: '6904870568009',
    //         variantId: '40537177096265',
    //         type: 2, //1 时间限定 2 数量限定
    //         stage: 1, // 1 第一个倒计时阶段 2 第二个倒计时阶段
    //         off: '',
    //         offTips: '',
    //         name: 'WAVE 2 Portable Air Conditioner + DELTA Pro',
    //         tag: 2,
    //         isEnd: false,
    //         img: '/media/wave2/crowdfunding/pc/3_us.png',
    //         mobileImg: '/media/wave2/crowdfunding/h5/3_us.png',
    //         include: ['WAVE 2 Portable Air Conditioner x 1', 'DELTA Pro x 1', 'XT150 Cable-1m(connects WAVE 2 to DELTA Pro) x 1', 'DELTA Pro Adapter x 1'],
    //         delivery_date: '',
    //         sale: 0,
    //         count: 400,
    //         discountPrice: 3699,
    //         originalPrice: 4999,
    //         price_suffix: '',
    //         sku: '6900906721353',
    //         node: 'product-component-1683727022040',
    //         buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
    //     },
    //     {
    //         id: '6904755617865',
    //         variantId: '40536746360905',
    //         type: 2,
    //         stage: 2, // 1 第一个倒计时阶段 2 第二个倒计时阶段
    //         off: '',
    //         offTips: '',
    //         name: 'WAVE 2 Portable Air Conditioner + DELTA Pro',
    //         tag: null,
    //         isEnd: false,
    //         img: '/media/wave2/crowdfunding/pc/3_us.png',
    //         mobileImg: '/media/wave2/crowdfunding/h5/3_us.png',
    //         include: ['WAVE 2 Portable Air Conditioner x 1', 'DELTA Pro x 1', 'XT150 Cable-1m(connects WAVE 2 to DELTA Pro) x 1', 'DELTA Pro Adapter x 1'],
    //         delivery_date: '',
    //         sale: 0,
    //         count: null,
    //         countdown: true, // 2023-05-24 卖不动、为刺激消费， @陈琨 要求添加倒计
    //         discountPrice: 4399,
    //         originalPrice: 4999,
    //         price_suffix: '',
    //         sku: '6900906721353',
    //         node: 'product-component-1683727229411',
    //         buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-super-early-bird',
    //     },
    // ],
    jp: [
        // 真实数据
        {
            id: '7677813653665',
            variantId: '42969106481313',
            type: 1, //1 时间限定 2 数量限定
            stage: 1, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            ignore: true, // 无限库存
            off: '25% OFF',
            offTips: '',
            name: 'WAVE 2 ポータブルエアコン',
            tag: 2,
            isEnd: false,
            img: '/media/wave2/crowdfunding/pc/1_jp.png',
            mobileImg: '/media/wave2/crowdfunding/h5/1_jp.png',
            include: [],
            delivery_date: '2023年5月10日から順次発送',
            sale: 0,
            count: null,
            inventory: 999,
            discountPrice: 107250,
            originalPrice: 143000,
            price_suffix: '(税込)',
            sku: 'ZMH200-H-ZMH200BP-B-JP',
            node: 'product-component-1680600952320',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
        },
        {
            id: '7677813653665',
            variantId: '42969106481313',
            type: 1,
            stage: 2, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            ignore: true, // 无限库存
            off: '20% OFF', // 0508 @陈琨 要求改价格 https://project.feishu.cn/mz820/story/detail/6790993
            offTips: '',
            name: 'WAVE 2 ポータブルエアコン',
            tag: 2,
            isEnd: false,
            img: '/media/wave2/crowdfunding/pc/1_jp.png',
            mobileImg: '/media/wave2/crowdfunding/h5/1_jp.png',
            include: [],
            delivery_date: '',
            sale: 0,
            count: null,
            discountPrice: 114400, // 0508 @陈琨 要求改价格 https://project.feishu.cn/mz820/story/detail/6790993
            originalPrice: 143000,
            price_suffix: '(税込)',
            sku: 'ZMH200-H-JP',
            node: 'product-component-1680600952320',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-super-early-bird',
        },

        {
            id: '7677813653665',
            variantId: '42969105498273',
            type: 1, //1 时间限定 2 数量限定
            stage: 1, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            ignore: true, // 无限库存
            off: '25% OFF',
            offTips: '',
            name: 'WAVE 2 ポータブルエアコン + WAVE 2 専用バッテリーパック',
            tag: 2,
            isEnd: false,
            img: '/media/wave2/crowdfunding/pc/2_jp.png',
            mobileImg: '/media/wave2/crowdfunding/h5/2_jp.png',
            include: [],
            delivery_date: '2023年5月10日から順次発送',
            sale: 0,
            count: null,
            discountPrice: 183980,
            originalPrice: 245300,
            price_suffix: '(税込)',
            sku: 'ZMH200-H-ZMH200BP-B-JP',
            node: 'product-component-1680600985126',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
        },
        {
            id: '7677813653665',
            variantId: '42969105498273',
            type: 1,
            stage: 2, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            ignore: true, // 无限库存
            off: '20% OFF', // 0508 @陈琨 要求改价格 https://project.feishu.cn/mz820/story/detail/6790993
            offTips: '',
            name: 'WAVE 2 ポータブルエアコン + WAVE 2 専用バッテリーパック',
            tag: 2,
            isEnd: false,
            img: '/media/wave2/crowdfunding/pc/2_jp.png',
            mobileImg: '/media/wave2/crowdfunding/h5/2_jp.png',
            include: [],
            delivery_date: '',
            sale: 0,
            count: null,
            discountPrice: 196240, // 0508 @陈琨 要求改价格 https://project.feishu.cn/mz820/story/detail/6790993
            originalPrice: 245300,
            price_suffix: '(税込)',
            sku: 'ZMH200-H-JP',
            node: 'product-component-1680600985126',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-super-early-bird',
        },

        {
            id: '7680671383713',
            variantId: '42969133318305',
            type: 1, //1 时间限定 2 数量限定
            stage: 1, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            ignore: true, // 无限库存
            off: '25% OFF',
            offTips: '',
            name: 'WAVE 2 ポータブルエアコン + GLACIER ポータブル冷蔵庫',
            tag: null,
            isEnd: false,
            img: '/media/wave2/crowdfunding/pc/7_jp.png',
            mobileImg: '/media/wave2/crowdfunding/h5/7_jp.png',
            include: [],
            delivery_date: '2023年5月10日から順次発送',
            sale: 0,
            count: null,
            discountPrice: 187280,
            originalPrice: 249700,
            price_suffix: '(税込)',
            sku: 'ZMH200-H-ZMH200BP-B-JP',
            node: 'product-component-1680601279749',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
        },
        {
            id: '7680671383713',
            variantId: '42969133318305',
            type: 1,
            stage: 2, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            ignore: true, // 无限库存
            off: '20% OFF', // 0508 @陈琨 要求改价格 https://project.feishu.cn/mz820/story/detail/6790993
            offTips: '',
            name: 'WAVE 2 ポータブルエアコン + GLACIER ポータブル冷蔵庫',
            tag: null,
            isEnd: false,
            img: '/media/wave2/crowdfunding/pc/7_jp.png',
            mobileImg: '/media/wave2/crowdfunding/h5/7_jp.png',
            include: [],
            delivery_date: '',
            sale: 0,
            count: null,
            discountPrice: 199760, // 0508 @陈琨 要求改价格 https://project.feishu.cn/mz820/story/detail/6790993
            originalPrice: 249700,
            price_suffix: '(税込)',
            sku: 'ZMH200-H-JP',
            node: 'product-component-1680601279749',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-super-early-bird',
        },

        {
            id: '7680671383713',
            variantId: '42969133351073',
            type: 1, //1 时间限定 2 数量限定
            stage: 1, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            ignore: true, // 无限库存
            off: '25% OFF',
            offTips: '',
            name: ' EcoFlow WAVE 2 ポータブルエアコン + WAVE 2 専用バッテリーパック + GLACIER ポータブル冷蔵庫 + GLACIER 専用バッテリーパック',
            tag: 2,
            isEnd: false,
            img: '/media/wave2/crowdfunding/pc/8_jp.png',
            mobileImg: '/media/wave2/crowdfunding/h5/8_jp.png',
            include: [],
            delivery_date: '2023年5月10日から順次発送',
            sale: 0,
            count: null,
            discountPrice: 292050,
            originalPrice: 389400,
            price_suffix: '(税込)',
            sku: 'ZMH200-H-ZMH200BP-B-JP',
            node: 'product-component-1680601305711',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
        },
        {
            id: '7680671383713',
            variantId: '42969133351073',
            type: 1,
            stage: 2, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            ignore: true, // 无限库存
            off: '20% OFF', // 0508 @陈琨 要求改价格 https://project.feishu.cn/mz820/story/detail/6790993
            offTips: '',
            name: ' EcoFlow WAVE 2 ポータブルエアコン + WAVE 2 専用バッテリーパック + GLACIER ポータブル冷蔵庫 + GLACIER 専用バッテリーパック',
            tag: null,
            isEnd: false,
            img: '/media/wave2/crowdfunding/pc/8_jp.png',
            mobileImg: '/media/wave2/crowdfunding/h5/8_jp.png',
            include: [],
            delivery_date: '',
            sale: 0,
            count: null,
            discountPrice: 311520, // 0508 @陈琨 要求改价格 https://project.feishu.cn/mz820/story/detail/6790993
            originalPrice: 389400,
            price_suffix: '(税込)',
            sku: 'ZMH200-H-JP',
            node: 'product-component-1680601305711',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-super-early-bird',
        },

        {
            id: '7680661520545',
            type: 1, //1 时间限定 2 数量限定
            stage: 1, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            ignore: true, // 无限库存
            off: '25% OFF',
            offTips: '',
            name: 'WAVE 2 ポータブルエアコン + DELTA 2',
            tag: 2,
            isEnd: false,
            img: '/media/wave2/crowdfunding/pc/3_jp.png',
            mobileImg: '/media/wave2/crowdfunding/h5/3_jp.png',
            include: [],
            delivery_date: '2023年5月10日から順次発送',
            sale: 0,
            count: null,
            discountPrice: 207900,
            originalPrice: 277200,
            price_suffix: '(税込)',
            sku: 'ZMH200-H-ZMH200BP-B-JP',
            node: 'product-component-1680601015839',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
        },
        {
            id: '7680661520545',
            type: 1,
            stage: 2, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            ignore: true, // 无限库存
            off: '20% OFF', // 0508 @陈琨 要求改价格 https://project.feishu.cn/mz820/story/detail/6790993
            offTips: '',
            name: 'WAVE 2 ポータブルエアコン + DELTA 2',
            tag: 2,
            isEnd: false,
            img: '/media/wave2/crowdfunding/pc/3_jp.png',
            mobileImg: '/media/wave2/crowdfunding/h5/3_jp.png',
            include: [],
            delivery_date: '',
            sale: 0,
            count: null,
            discountPrice: 221760, // 0508 @陈琨 要求改价格 https://project.feishu.cn/mz820/story/detail/6790993
            originalPrice: 277200,
            price_suffix: '(税込)',
            sku: 'ZMH200-H-JP',
            node: 'product-component-1680601015839',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-super-early-bird',
        },

        {
            id: '7680672497825',
            type: 1, //1 时间限定 2 数量限定
            stage: 1, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            ignore: true, // 无限库存
            off: '30% OFF',
            offTips: '',
            name: 'WAVE 2 ポータブルエアコン + DELTA Max 2000',
            tag: null,
            isEnd: false,
            img: '/media/wave2/crowdfunding/pc/4_jp.png',
            mobileImg: '/media/wave2/crowdfunding/h5/4_jp.png',
            include: [],
            delivery_date: '2023年5月10日から順次発送',
            sale: 0,
            count: null,
            discountPrice: 261030,
            originalPrice: 372900,
            price_suffix: '(税込)',
            sku: 'ZMH200-H-ZMH200BP-B-JP',
            node: 'product-component-1680601350385',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
        },
        {
            id: '7680672497825',
            type: 1,
            stage: 2, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            ignore: true, // 无限库存
            off: '25% OFF', // 0508 @陈琨 要求改价格 https://project.feishu.cn/mz820/story/detail/6790993
            offTips: '',
            name: 'WAVE 2 ポータブルエアコン + DELTA Max 2000',
            tag: null,
            isEnd: false,
            img: '/media/wave2/crowdfunding/pc/4_jp.png',
            mobileImg: '/media/wave2/crowdfunding/h5/4_jp.png',
            include: [],
            delivery_date: '',
            sale: 0,
            count: null,
            discountPrice: 279680, // 0508 @陈琨 要求改价格 https://project.feishu.cn/mz820/story/detail/6790993
            originalPrice: 372900,
            price_suffix: '(税込)',
            sku: 'ZMH200-H-JP',
            node: 'product-component-1680601350385',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-super-early-bird',
        },

        {
            id: '7680668172449',
            type: 1, //1 时间限定 2 数量限定
            stage: 1, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            ignore: true, // 无限库存
            off: '25% OFF',
            offTips: '',
            name: 'WAVE 2 ポータブルエアコン + WAVE 2 専用バッテリーパック + 400Wソーラーパネル',
            tag: null,
            isEnd: false,
            img: '/media/wave2/crowdfunding/pc/5_jp.png',
            mobileImg: '/media/wave2/crowdfunding/h5/5_jp.png',
            include: [],
            delivery_date: '2023年5月10日から順次発送',
            sale: 0,
            count: null,
            discountPrice: 275550,
            originalPrice: 367400,
            price_suffix: '(税込)',
            sku: 'ZMH200-H-ZMH200BP-B-JP',
            node: 'product-component-1680601127560',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
        },
        {
            id: '7680668172449',
            type: 1,
            stage: 2, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            ignore: true, // 无限库存
            off: '20% OFF', // 0508 @陈琨 要求改价格 https://project.feishu.cn/mz820/story/detail/6790993
            offTips: '',
            name: 'WAVE 2 ポータブルエアコン + WAVE 2 専用バッテリーパック + 400Wソーラーパネル',
            tag: null,
            isEnd: false,
            img: '/media/wave2/crowdfunding/pc/5_jp.png',
            mobileImg: '/media/wave2/crowdfunding/h5/5_jp.png',
            include: [],
            delivery_date: '',
            sale: 0,
            count: null,
            discountPrice: 293920, // 0508 @陈琨 要求改价格 https://project.feishu.cn/mz820/story/detail/6790993
            originalPrice: 367400,
            price_suffix: '(税込)',
            sku: 'ZMH200-H-JP',
            node: 'product-component-1680601127560',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-super-early-bird',
        },

        {
            id: '7680673743009',
            type: 1, //1 时间限定 2 数量限定
            stage: 1, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            ignore: true, // 无限库存
            off: '30% OFF',
            offTips: '',
            name: 'WAVE 2 ポータブルエアコン + DELTA Max 2000 + 400Wソーラーパネル',
            tag: null,
            isEnd: false,
            img: '/media/wave2/crowdfunding/pc/6_jp.png',
            mobileImg: '/media/wave2/crowdfunding/h5/6_jp.png',
            include: [],
            delivery_date: '2023年5月10日から順次発送',
            sale: 0,
            count: null,
            discountPrice: 346500,
            originalPrice: 495000,
            price_suffix: '(税込)',
            sku: 'ZMH200-H-ZMH200BP-B-JP',
            node: 'product-component-1680601375465',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
        },
        {
            id: '7680673743009',
            type: 1,
            stage: 2, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            ignore: true, // 无限库存
            off: '25% OFF', // 0508 @陈琨 要求改价格 https://project.feishu.cn/mz820/story/detail/6790993
            offTips: '',
            name: 'WAVE 2 ポータブルエアコン + DELTA Max 2000 + 400Wソーラーパネル',
            tag: null,
            isEnd: false,
            img: '/media/wave2/crowdfunding/pc/6_jp.png',
            mobileImg: '/media/wave2/crowdfunding/h5/6_jp.png',
            include: [],
            delivery_date: '',
            sale: 0,
            count: null,
            discountPrice: 371250, // 0508 @陈琨 要求改价格 https://project.feishu.cn/mz820/story/detail/6790993
            originalPrice: 495000,
            price_suffix: '(税込)',
            sku: 'ZMH200-H-JP',
            node: 'product-component-1680601375465',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-super-early-bird',
        },
    ],
    // 以下所有欧洲站点早鸟， 都是突然新增的 @陈琨那个混蛋 0509， 0512需要上线（定时任务0515开启早鸟）
    // 0614～0616上线 欧洲六站 夏季促销早鸟-正常早鸟 @陈琨
    // @sunny 0902 欧洲六站价格变更
    eu: [
        // 真实数据
        // WAVE 2 Portable Air Conditioner
        {
            id: '8368405807447',
            variantId: '46493661954391',
            type: 1, // type 1: 时间限定 2: 库存限定 3: 仅有一个时间阶段无限库存
            stage: 1, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            ignore: true, // 无限库存
            off: '',
            offTips: '',
            name: 'WAVE 2 Portable Air Conditioner',
            tag: 'Limited Offer',
            isEnd: false,
            img: '/media/wave2/crowdfunding/pc/1.png',
            mobileImg: '/media/wave2/crowdfunding/h5/1.png',
            include: ['WAVE 2 Portable Air Conditioner x 1'],
            delivery_date: '',
            sale: 0,
            count: null,
            countdown: true,
            discountPrice: 1099,
            originalPrice: 1199,
            price_suffix: '',
            sku: 'ZYDKT210-US',
            node: 'product-component-1683628221331',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-super-early-bird',
        },
        {
            id: '8368405807447',
            variantId: '46493661954391',
            type: 1, // type 1: 库存限定 2: 时间限定 3: 仅有一个时间阶段无限库存
            stage: 2, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            ignore: true, // 无限库存
            off: '',
            offTips: '',
            name: 'WAVE 2 Portable Air Conditioner',
            tag: null,
            isEnd: false,
            img: '/media/wave2/crowdfunding/pc/1.png',
            mobileImg: '/media/wave2/crowdfunding/h5/1.png',
            include: ['WAVE 2 Portable Air Conditioner x 1'],
            delivery_date: '',
            sale: 0,
            count: null,
            countdown: false,
            discountPrice: 999,
            originalPrice: 1199,
            price_suffix: '',
            sku: 'ZYDKT210-US',
            node: 'product-component-1683628221331',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-super-early-bird',
        },

        // WAVE 2 Portable Air Conditioner + Add-on Battery
        {
            id: '8368405807447',
            variantId: '46493661921623',
            type: 1,
            stage: 1, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            ignore: true, // 无限库存
            off: '',
            offTips: '',
            name: 'WAVE 2 + Add-on battery',
            tag: 'Limited Offer',
            isEnd: false,
            img: '/media/wave2/crowdfunding/pc/2.png',
            mobileImg: '/media/wave2/crowdfunding/h5/2.png',
            include: ['WAVE 2 Portable Air Conditioner x 1', 'WAVE 2 Add-on Battery x 1'],
            delivery_date: '',
            sale: 0,
            count: null,
            countdown: true,
            discountPrice: 1799,
            originalPrice: 2098,
            price_suffix: '',
            sku: 'WAVE2-EB',
            node: 'product-component-1683629772676',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-super-early-bird',
        },
        {
            id: '8368405807447',
            variantId: '46493661921623',
            type: 1,
            stage: 2, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            ignore: true, // 无限库存
            off: '',
            offTips: '',
            name: 'WAVE 2 + Add-on battery',
            tag: null,
            isEnd: false,
            img: '/media/wave2/crowdfunding/pc/2.png',
            mobileImg: '/media/wave2/crowdfunding/h5/2.png',
            include: ['WAVE 2 Portable Air Conditioner x 1', 'WAVE 2 Add-on Battery x 1'],
            delivery_date: '',
            sale: 0,
            count: null,
            countdown: false,
            discountPrice: 1699,
            originalPrice: 1999,
            price_suffix: '',
            sku: 'WAVE2-EB',
            node: 'product-component-1683629772676',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-super-early-bird',
        },

        // EcoFlow WAVE 2 Portable Air Conditioner + DELTA 2
        {
            id: '8364075123031',
            variantId: '46496822591831',
            type: 1,
            stage: 1, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            ignore: true, // 无限库存
            off: '',
            offTips: '',
            name: 'WAVE 2 + DELTA 2',
            tag: 'Limited Offer',
            isEnd: false,
            img: '/media/wave2/crowdfunding/pc/3_eu.png',
            mobileImg: '/media/wave2/crowdfunding/h5/3_eu.png',
            include: ['WAVE 2 Portable Air Conditioner x 1', 'DELTA 2 Portable Power Station x 1', 'XT150 Cable-1m (connects WAVE 2 to DELTA 2) x 1'],
            delivery_date: '',
            sale: 0,
            count: null,
            countdown: true,
            discountPrice: 2098,
            originalPrice: 2398,
            price_suffix: '',
            sku: '6900906721353',
            node: 'product-component-1683630332211',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-super-early-bird',
        },
        {
            id: '8364075123031',
            variantId: '46496822591831',
            type: 1,
            stage: 2, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            ignore: true, // 无限库存
            off: '',
            offTips: '',
            name: 'WAVE 2 + DELTA 2',
            tag: null,
            isEnd: false,
            img: '/media/wave2/crowdfunding/pc/3_eu.png',
            mobileImg: '/media/wave2/crowdfunding/h5/3_eu.png',
            include: ['WAVE 2 Portable Air Conditioner x 1', 'DELTA 2 Portable Power Station x 1', 'XT150 Cable-1m (connects WAVE 2 to DELTA 2) x 1'],
            delivery_date: '',
            sale: 0,
            count: null,
            countdown: false,
            discountPrice: 2198,
            originalPrice: 2398,
            price_suffix: '',
            sku: '6900906721353',
            node: 'product-component-1683630332211',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-super-early-bird',
        },

        // 0606 @陈琨 要求delta max更换为delta2max
        // 0616 @陈琨 夏季促销

        // EcoFlow WAVE 2 Portable Air Conditioner + DELTA Max
        {
            id: '8369188438359',
            variantId: '46496825803095',
            type: 1,
            stage: 1, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            ignore: true, // 无限库存
            off: '',
            offTips: '',
            name: 'WAVE 2 + DELTA Max',
            tag: 'Limited Offer',
            isEnd: false,
            img: '/media/wave2/crowdfunding/pc/4_us.png',
            mobileImg: '/media/wave2/crowdfunding/h5/4_us.png',
            include: ['WAVE 2 Portable Air Conditioner x 1', 'DELTA Max 2000 Portable Power Station x 1', 'XT150 Cable-1m (connects WAVE 2 to DELTA Max) x 1'],
            delivery_date: '',
            sale: 0,
            count: null,
            countdown: true,
            discountPrice: 2798,
            originalPrice: 3498,
            price_suffix: '',
            sku: '6900906721353',
            node: 'product-component-1683630381616',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
        },
        // EcoFlow WAVE 2 Portable Air Conditioner + DELTA Max
        {
            id: '8369188438359',
            variantId: '46496825803095',
            type: 1,
            stage: 2, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            ignore: true, // 无限库存
            off: '',
            offTips: '',
            name: 'WAVE 2 + DELTA Max',
            tag: null,
            isEnd: false,
            img: '/media/wave2/crowdfunding/pc/4_us.png',
            mobileImg: '/media/wave2/crowdfunding/h5/4_us.png',
            include: ['WAVE 2 Portable Air Conditioner x 1', 'DELTA Max 2000 Portable Power Station x 1', 'XT150 Cable-1m (connects WAVE 2 to DELTA Max) x 1'],
            delivery_date: '',
            sale: 0,
            count: null,
            // countdown: true,
            discountPrice: 2898,
            originalPrice: 3098,
            price_suffix: '',
            sku: '6900906721353',
            node: 'product-component-1683630381616',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
        },

        // // WAVE 2  + DELTA 2 Max
        // {
        //     id: '8431262073175',
        //     variantId: '46766752039255',
        //     type: 1,
        //     stage: 2, // 1 第一个倒计时阶段 2 第二个倒计时阶段
        //     ignore: true, // 无限库存
        //     off: '',
        //     offTips: '',
        //     name: 'WAVE 2  + DELTA 2 Max',
        //     tag: null,
        //     isEnd: false,
        //     img: '/media/wave2/crowdfunding/pc/4_us.png',
        //     mobileImg: '/media/wave2/crowdfunding/h5/4_us.png',
        //     include: ['WAVE 2 Portable Air Conditioner x 1', 'DELTA 2 Max Portable Power Station x 1', 'XT150 Cable-1m (connects WAVE 2 to DELTA 2 Max) x 1'],
        //     delivery_date: '',
        //     sale: 0,
        //     count: null,
        //     countdown: false,
        //     discountPrice: 3298,
        //     originalPrice: 3298,
        //     price_suffix: '',
        //     sku: '46766752039255',
        //     node: 'product-component-1686033260892',
        //     buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
        // },
    ],
    uk: [
        // 真实数据
        // WAVE 2 Portable Air Conditioner
        {
            id: '8376008704339',
            variantId: '46526037786963',
            type: 1,
            stage: 1, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            ignore: true, // 无限库存
            off: '',
            offTips: '',
            name: 'WAVE 2 Portable Air Conditioner',
            tag: 'Limited Offer',
            isEnd: false,
            img: '/media/wave2/crowdfunding/pc/1.png',
            mobileImg: '/media/wave2/crowdfunding/h5/1.png',
            include: ['WAVE 2 Portable Air Conditioner x 1'],
            delivery_date: '',
            sale: 0,
            count: null,
            countdown: true,
            discountPrice: 949,
            originalPrice: 1049,
            price_suffix: '',
            sku: 'ZYDKT210-US',
            node: 'product-component-1683630507543',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-super-early-bird',
        },
        {
            id: '8376008704339',
            variantId: '46526037786963',
            type: 1,
            stage: 2, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            ignore: true, // 无限库存
            off: '',
            offTips: '',
            name: 'WAVE 2 Portable Air Conditioner',
            tag: null,
            isEnd: false,
            img: '/media/wave2/crowdfunding/pc/1.png',
            mobileImg: '/media/wave2/crowdfunding/h5/1.png',
            include: ['WAVE 2 Portable Air Conditioner x 1'],
            delivery_date: '',
            sale: 0,
            count: null,
            countdown: false,
            discountPrice: 849,
            originalPrice: 1049,
            price_suffix: '',
            sku: 'ZYDKT210-US',
            node: 'product-component-1683630507543',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-super-early-bird',
        },

        // WAVE 2 Portable Air Conditioner + Add-on Battery
        {
            id: '8376008704339',
            variantId: '46526037819731',
            type: 1,
            stage: 1, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            ignore: true, // 无限库存
            off: '',
            offTips: '',
            name: 'WAVE 2 + Add-on battery',
            tag: 'Limited Offer',
            isEnd: false,
            img: '/media/wave2/crowdfunding/pc/2.png',
            mobileImg: '/media/wave2/crowdfunding/h5/2.png',
            include: ['WAVE 2 Portable Air Conditioner x 1', 'WAVE 2 Add-on Battery x 1'],
            delivery_date: '',
            sale: 0,
            count: null,
            countdown: true,
            discountPrice: 1599,
            originalPrice: 1848,
            price_suffix: '',
            sku: 'WAVE2-EB',
            node: 'product-component-1683630550403',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-super-early-bird',
        },
        {
            id: '8376008704339',
            variantId: '46526037819731',
            type: 1,
            stage: 2, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            ignore: true, // 无限库存
            off: '',
            offTips: '',
            name: 'WAVE 2 + Add-on battery',
            tag: null,
            isEnd: false,
            img: '/media/wave2/crowdfunding/pc/2.png',
            mobileImg: '/media/wave2/crowdfunding/h5/2.png',
            include: ['WAVE 2 Portable Air Conditioner x 1', 'WAVE 2 Add-on Battery x 1'],
            delivery_date: '',
            sale: 0,
            count: null,
            discountPrice: 1499,
            originalPrice: 1799,
            price_suffix: '',
            sku: 'WAVE2-EB',
            node: 'product-component-1683630550403',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-super-early-bird',
        },

        // EcoFlow WAVE 2 Portable Air Conditioner + DELTA 2
        {
            id: '8375914889555',
            variantId: '46525875290451',
            type: 1,
            stage: 1, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            ignore: true, // 无限库存
            off: '',
            offTips: '',
            name: 'WAVE 2 + DELTA 2',
            tag: 'Limited Offer',
            isEnd: false,
            img: '/media/wave2/crowdfunding/pc/3_eu.png',
            mobileImg: '/media/wave2/crowdfunding/h5/3_eu.png',
            include: ['WAVE 2 Portable Air Conditioner x 1', 'DELTA 2 Portable Power Station x 1', 'XT150 Cable-1m (connects WAVE 2 to DELTA 2) x 1'],
            delivery_date: '',
            sale: 0,
            count: null,
            countdown: true,
            discountPrice: 1848,
            originalPrice: 2148,
            price_suffix: '',
            sku: '6900906721353',
            node: 'product-component-1683630669725',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-super-early-bird',
        },
        {
            id: '8375914889555',
            variantId: '46525875290451',
            type: 1,
            stage: 2, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            ignore: true, // 无限库存
            off: '',
            offTips: '',
            name: 'WAVE 2 + DELTA 2',
            tag: null,
            isEnd: false,
            img: '/media/wave2/crowdfunding/pc/3_eu.png',
            mobileImg: '/media/wave2/crowdfunding/h5/3_eu.png',
            include: ['WAVE 2 Portable Air Conditioner x 1', 'DELTA 2 Portable Power Station x 1', 'XT150 Cable-1m (connects WAVE 2 to DELTA 2) x 1'],
            delivery_date: '',
            sale: 0,
            count: null,
            countdown: false,
            discountPrice: 1948,
            originalPrice: 2148,
            price_suffix: '',
            sku: '6900906721353',
            node: 'product-component-1683630669725',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-super-early-bird',
        },

        // 0616 夏季促销
        // // EcoFlow WAVE 2 Portable Air Conditioner + DELTA 2 Max
        // {
        //     id: '8420911874387',
        //     variantId: '46655512904019',
        //     type: 3,
        //     stage: 2, // 1 第一个倒计时阶段 2 第二个倒计时阶段
        //     off: '',
        //     offTips: '',
        //     name: 'WAVE 2 + DELTA 2 Max',
        //     tag: null,
        //     isEnd: false,
        //     img: '/media/wave2/crowdfunding/pc/3_eu.png',
        //     mobileImg: '/media/wave2/crowdfunding/h5/3_eu.png',
        //     include: ['WAVE 2 Portable Air Conditioner x 1', 'DELTA 2 Max Portable Power Station x 1', 'XT150 Cable-1m (connects WAVE 2 to DELTA 2 Max) x 1'],
        //     delivery_date: '',
        //     sale: 0,
        //     count: null,
        //     discountPrice: 2948,
        //     originalPrice: 2948,
        //     price_suffix: '',
        //     sku: '46655512904019',
        //     node: 'product-component-1686033514618',
        //     buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-super-early-bird',
        // },

        // EcoFlow WAVE 2 Portable Air Conditioner + DELTA Max
        {
            id: '8375987962195',
            variantId: '46525988110675',
            type: 1,
            stage: 1, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            ignore: true, // 无限库存
            off: '',
            offTips: '',
            name: 'WAVE 2 + DELTA Max',
            tag: 'Limited Offer',
            isEnd: false,
            img: '/media/wave2/crowdfunding/pc/4_us.png',
            mobileImg: '/media/wave2/crowdfunding/h5/4_us.png',
            include: ['WAVE 2 Portable Air Conditioner x 1', 'DELTA Max 2000 Portable Power Station x 1', 'XT150 Cable-1m (connects WAVE 2 to DELTA Max) x 1'],
            delivery_date: '',
            sale: 0,
            count: null,
            countdown: true,
            discountPrice: 2448,
            originalPrice: 3048,
            price_suffix: '',
            sku: '6900906721353',
            node: 'product-component-1683630601410',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
        },
        // EcoFlow WAVE 2 Portable Air Conditioner + DELTA Max
        {
            id: '8375987962195',
            variantId: '46525988110675',
            type: 1,
            stage: 2, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            ignore: true, // 无限库存
            off: '',
            offTips: '',
            name: 'WAVE 2 + DELTA Max',
            tag: null,
            isEnd: false,
            img: '/media/wave2/crowdfunding/pc/4_us.png',
            mobileImg: '/media/wave2/crowdfunding/h5/4_us.png',
            include: ['WAVE 2 Portable Air Conditioner x 1', 'DELTA Max 2000 Portable Power Station x 1', 'XT150 Cable-1m (connects WAVE 2 to DELTA Max) x 1'],
            delivery_date: '',
            sale: 0,
            count: null,
            // countdown: true,
            discountPrice: 2548,
            originalPrice: 2748,
            price_suffix: '',
            sku: '6900906721353',
            node: 'product-component-1683630601410',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
        },
        // // EcoFlow WAVE 2 Portable Air Conditioner + DELTA 2 Max
        // {
        //     id: '8420911874387',
        //     variantId: '46655512904019',
        //     type: 1,
        //     stage: 2, // 1 第一个倒计时阶段 2 第二个倒计时阶段
        //     ignore: true, // 无限库存
        //     off: '',
        //     offTips: '',
        //     name: 'WAVE 2 + DELTA 2 Max',
        //     tag: null,
        //     isEnd: false,
        //     img: '/media/wave2/crowdfunding/pc/3_eu.png',
        //     mobileImg: '/media/wave2/crowdfunding/h5/3_eu.png',
        //     include: ['WAVE 2 Portable Air Conditioner x 1', 'DELTA 2 Max Portable Power Station x 1', 'XT150 Cable-1m (connects WAVE 2 to DELTA 2 Max) x 1'],
        //     delivery_date: '',
        //     sale: 0,
        //     count: null,
        //     discountPrice: 2948,
        //     originalPrice: 2948,
        //     price_suffix: '',
        //     sku: '46655512904019',
        //     node: 'product-component-1686033514618',
        //     buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-super-early-bird',
        // },
    ],
    de: [
        // 真实数据
        // WAVE 2 Portable Air Conditioner
        {
            id: '8376354537807',
            variantId: '46538134126927',
            ignore: true, // 无限库存
            type: 1,
            stage: 1, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            off: '',
            offTips: '',
            name: 'WAVE 2 Tragbare Klimaanlage',
            tag: 'Begrenztes Angebot',
            isEnd: false,
            img: '/media/wave2/crowdfunding/pc/1.png',
            mobileImg: '/media/wave2/crowdfunding/h5/1.png',
            include: ['WAVE 2 Tragbare Klimaanlage x 1'],
            delivery_date: '',
            sale: 0,
            count: null,
            countdown: true,
            discountPrice: 1099,
            originalPrice: 1199,
            price_suffix: '',
            sku: 'ZYDKT210-US',
            node: 'product-component-1683628903720',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-super-early-bird',
        },
        {
            id: '8376354537807',
            variantId: '46538134126927',
            ignore: true, // 无限库存
            type: 1,
            stage: 2, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            off: '',
            offTips: '',
            name: 'WAVE 2 Tragbare Klimaanlage',
            tag: null,
            isEnd: false,
            img: '/media/wave2/crowdfunding/pc/1.png',
            mobileImg: '/media/wave2/crowdfunding/h5/1.png',
            include: ['WAVE 2 Tragbare Klimaanlage x 1'],
            delivery_date: '',
            sale: 0,
            count: null,
            countdown: false,
            discountPrice: 999,
            originalPrice: 1199,
            price_suffix: '',
            sku: 'ZYDKT210-US',
            node: 'product-component-1683628903720',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-super-early-bird',
        },

        // WAVE 2 Portable Air Conditioner + Add-on Battery
        {
            id: '8376354537807',
            variantId: '46538134094159',
            ignore: true, // 无限库存
            type: 1,
            stage: 1, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            off: '',
            offTips: '',
            name: 'WAVE 2 + Zusatzbatterie',
            tag: 'Begrenztes Angebot',
            isEnd: false,
            img: '/media/wave2/crowdfunding/pc/2.png',
            mobileImg: '/media/wave2/crowdfunding/h5/2.png',
            include: ['WAVE 2 Tragbare Klimaanlage x 1', 'WAVE 2 Zusatzbatterie x 1'],
            delivery_date: '',
            sale: 0,
            count: null,
            countdown: true,
            discountPrice: 1799,
            originalPrice: 2098,
            price_suffix: '',
            sku: 'WAVE2-EB',
            node: 'product-component-1683628998783',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-super-early-bird',
        },
        {
            id: '8376354537807',
            variantId: '46538134094159',
            ignore: true, // 无限库存
            type: 1,
            stage: 2, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            off: '',
            offTips: '',
            name: 'WAVE 2 + Zusatzbatterie',
            tag: null,
            isEnd: false,
            img: '/media/wave2/crowdfunding/pc/2.png',
            mobileImg: '/media/wave2/crowdfunding/h5/2.png',
            include: ['WAVE 2 Tragbare Klimaanlage x 1', 'WAVE 2 Zusatzbatterie x 1'],
            delivery_date: '',
            sale: 0,
            count: null,
            countdown: false,
            discountPrice: 1699,
            originalPrice: 1999,
            price_suffix: '',
            sku: 'WAVE2-EB',
            node: 'product-component-1683628998783',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-super-early-bird',
        },

        // EcoFlow WAVE 2 Portable Air Conditioner + DELTA 2
        {
            id: '8479729123663',
            variantId: '46557865673039',
            type: 1,
            stage: 1, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            ignore: true, // 无限库存
            off: '',
            offTips: '',
            name: 'WAVE 2 + DELTA 2',
            tag: 'Begrenztes Angebot',
            isEnd: false,
            img: '/media/wave2/crowdfunding/pc/3_eu.png',
            mobileImg: '/media/wave2/crowdfunding/h5/3_eu.png',
            include: ['WAVE 2 Tragbare Klimaanlage x 1', 'DELTA 2 Tragbare Powerstation x 1', 'XT150 Kabel-1m (verbindet WAVE 2 mit DELTA 2) x 1'],
            delivery_date: '',
            sale: 0,
            count: null,
            countdown: true,
            discountPrice: 2098,
            originalPrice: 2398,
            price_suffix: '',
            sku: '6900906721353',
            node: 'product-component-1683629049782',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-super-early-bird',
        },
        {
            id: '8479729123663',
            variantId: '46557865673039',
            type: 1,
            stage: 2, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            ignore: true, // 无限库存
            off: '',
            offTips: '',
            name: 'WAVE 2 + DELTA 2',
            tag: null,
            isEnd: false,
            img: '/media/wave2/crowdfunding/pc/3_eu.png',
            mobileImg: '/media/wave2/crowdfunding/h5/3_eu.png',
            include: ['WAVE 2 Tragbare Klimaanlage x 1', 'DELTA 2 Tragbare Powerstation x 1', 'XT150 Kabel-1m (verbindet WAVE 2 mit DELTA 2) x 1'],
            delivery_date: '',
            sale: 0,
            count: null,
            countdown: false,
            discountPrice: 2198,
            originalPrice: 2398,
            price_suffix: '',
            sku: '6900906721353',
            node: 'product-component-1683629049782',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-super-early-bird',
        },

        // EcoFlow WAVE 2 Portable Air Conditioner + DELTA 2 Max
        // 0616 夏季促销 @陈琨
        // {
        //     id: '8518507856207',
        //     variantId: '46698994729295',
        //     type: 3,
        //     stage: 2, // 1 第一个倒计时阶段 2 第二个倒计时阶段
        //     off: '',
        //     offTips: '',
        //     name: 'WAVE 2 + DELTA 2 Max',
        //     tag: null,
        //     isEnd: false,
        //     img: '/media/wave2/crowdfunding/pc/3_eu.png',
        //     mobileImg: '/media/wave2/crowdfunding/h5/3_eu.png',
        //     include: ['WAVE 2 Tragbare Klimaanlage x 1', 'DELTA 2 Max Tragbare Powerstation x 1', 'XT150 Kabel-1m (verbindet WAVE 2 mit DELTA 2 Max) x 1'],
        //     delivery_date: '',
        //     sale: 0,
        //     count: null,
        //     discountPrice: 3298,
        //     originalPrice: 3298,
        //     price_suffix: '',
        //     sku: '46698994729295',
        //     node: 'product-component-1686033450004',
        //     buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-super-early-bird',
        // },

        // EcoFlow WAVE 2 Portable Air Conditioner + DELTA Max
        {
            id: '8502317187407',
            variantId: '46645526593871',
            type: 1,
            stage: 1, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            ignore: true, // 无限库存
            off: '',
            offTips: '',
            name: 'WAVE 2 + DELTA Max',
            tag: 'Begrenztes Angebot',
            isEnd: false,
            img: '/media/wave2/crowdfunding/pc/4.png',
            mobileImg: '/media/wave2/crowdfunding/h5/4.png',
            include: ['WAVE 2 Tragbare Klimaanlage x 1', 'DELTA Max 2000 Tragbare Powerstation x 1', 'XT150 Kabel-1m (verbindet WAVE 2 mit DELTA Max) x 1'],
            delivery_date: '',
            sale: 0,
            count: null,
            countdown: true,
            discountPrice: 2798,
            originalPrice: 3498,
            price_suffix: '',
            sku: '6900906721353',
            node: 'product-component-1684155339871',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
        },
        {
            id: '8502317187407',
            variantId: '46645526593871',
            type: 1,
            stage: 2, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            ignore: true, // 无限库存
            off: '',
            offTips: '',
            name: 'WAVE 2 + DELTA Max',
            tag: null,
            isEnd: false,
            img: '/media/wave2/crowdfunding/pc/4.png',
            mobileImg: '/media/wave2/crowdfunding/h5/4.png',
            include: ['WAVE 2 Tragbare Klimaanlage x 1', 'DELTA Max 2000 Tragbare Powerstation x 1', 'XT150 Kabel-1m (verbindet WAVE 2 mit DELTA Max) x 1'],
            delivery_date: '',
            sale: 0,
            count: null,
            // countdown: true,
            discountPrice: 2898,
            originalPrice: 3098,
            price_suffix: '',
            sku: '6900906721353',
            node: 'product-component-1684155339871',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
        },
        // {
        //     id: '8518507856207',
        //     variantId: '46698994729295',
        //     type: 1,
        //     stage: 2, // 1 第一个倒计时阶段 2 第二个倒计时阶段
        //     ignore: true, // 无限库存
        //     off: '',
        //     offTips: '',
        //     name: 'WAVE 2 + DELTA 2 Max',
        //     tag: null,
        //     isEnd: false,
        //     img: '/media/wave2/crowdfunding/pc/4_eu.png',
        //     mobileImg: '/media/wave2/crowdfunding/h5/4_eu.png',
        //     include: ['WAVE 2 Tragbare Klimaanlage x 1', 'DELTA 2 Max Tragbare Powerstation x 1', 'XT150 Kabel-1m (verbindet WAVE 2 mit DELTA 2 Max) x 1'],
        //     delivery_date: '',
        //     sale: 0,
        //     count: null,
        //     countdown: false,
        //     discountPrice: 3298,
        //     originalPrice: 3298,
        //     price_suffix: '',
        //     sku: '46698994729295',
        //     node: 'product-component-1686033450004',
        //     buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-super-early-bird',
        // },
    ],
    fr: [
        // 真实数据
        // WAVE 2 Portable Air Conditioner
        {
            id: '8370477728091',
            variantId: '46505472164187',
            ignore: true, // 无限库存
            type: 1,
            stage: 1, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            off: '',
            offTips: '',
            name: 'Climatiseur portable WAVE 2',
            tag: 'Offre limitée',
            isEnd: false,
            img: '/media/wave2/crowdfunding/pc/1.png',
            mobileImg: '/media/wave2/crowdfunding/h5/1.png',
            include: ['Climatiseur portable WAVE 2 x 1'],
            delivery_date: '',
            sale: 0,
            count: null,
            countdown: true,
            discountPrice: 1099,
            originalPrice: 1199,
            price_suffix: '',
            sku: 'ZYDKT210-US',
            node: 'product-component-1683629800243',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-super-early-bird',
        },
        {
            id: '8370477728091',
            variantId: '46505472164187',
            ignore: true, // 无限库存
            type: 1,
            stage: 2, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            off: '',
            offTips: '',
            name: 'Climatiseur portable WAVE 2',
            tag: null,
            isEnd: false,
            img: '/media/wave2/crowdfunding/pc/1.png',
            mobileImg: '/media/wave2/crowdfunding/h5/1.png',
            include: ['Climatiseur portable WAVE 2 x 1'],
            delivery_date: '',
            sale: 0,
            count: null,
            countdown: false,
            discountPrice: 999,
            originalPrice: 1199,
            price_suffix: '',
            sku: 'ZYDKT210-US',
            node: 'product-component-1683629800243',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-super-early-bird',
        },

        // WAVE 2 Portable Air Conditioner + Add-on Battery
        {
            id: '8370477728091',
            variantId: '46505472131419',
            type: 1,
            stage: 1, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            ignore: true, // 无限库存
            off: '',
            offTips: '',
            name: 'WAVE 2 + batterie supplémentaire',
            tag: 'Offre limitée',
            isEnd: false,
            img: '/media/wave2/crowdfunding/pc/2.png',
            mobileImg: '/media/wave2/crowdfunding/h5/2.png',
            include: ['Climatiseur portable WAVE 2 x 1', 'Batterie supplémentaire pour WAVE 2 x 1'],
            delivery_date: '',
            sale: 0,
            count: null,
            countdown: true,
            discountPrice: 1799,
            originalPrice: 2098,
            price_suffix: '',
            sku: 'WAVE2-EB',
            node: 'product-component-1683629837939',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-super-early-bird',
        },
        {
            id: '8370477728091',
            variantId: '46505472131419',
            type: 1,
            stage: 2, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            ignore: true, // 无限库存
            off: '',
            offTips: '',
            name: 'WAVE 2 + batterie supplémentaire',
            tag: null,
            isEnd: false,
            img: '/media/wave2/crowdfunding/pc/2.png',
            mobileImg: '/media/wave2/crowdfunding/h5/2.png',
            include: ['Climatiseur portable WAVE 2 x 1', 'Batterie supplémentaire pour WAVE 2 x 1'],
            delivery_date: '',
            sale: 0,
            count: null,
            countdown: false,
            discountPrice: 1699,
            originalPrice: 1999,
            price_suffix: '',
            sku: 'WAVE2-EB',
            node: 'product-component-1683629837939',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-super-early-bird',
        },

        // EcoFlow WAVE 2 Portable Air Conditioner + DELTA 2
        {
            id: '8370479595867',
            variantId: '46505490186587',
            type: 1,
            stage: 1, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            ignore: true, // 无限库存
            off: '',
            offTips: '',
            name: 'WAVE 2 + DELTA 2',
            tag: 'Offre limitée',
            isEnd: false,
            img: '/media/wave2/crowdfunding/pc/3_eu.png',
            mobileImg: '/media/wave2/crowdfunding/h5/3_eu.png',
            include: ['Climatiseur portable WAVE 2 x 1', 'Station électrique portable DELTA 2 x 1', 'Câble XT150-1m (connecte WAVE 2 à DELTA 2) x 1'],
            delivery_date: '',
            sale: 0,
            count: null,
            countdown: true,
            discountPrice: 2098,
            originalPrice: 2398,
            price_suffix: '',
            sku: '6900906721353',
            node: 'product-component-1683629871400',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-super-early-bird',
        },
        {
            id: '8370479595867',
            variantId: '46505490186587',
            type: 1,
            stage: 2, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            ignore: true, // 无限库存
            off: '',
            offTips: '',
            name: 'WAVE 2 + DELTA 2',
            tag: null,
            isEnd: false,
            img: '/media/wave2/crowdfunding/pc/3_eu.png',
            mobileImg: '/media/wave2/crowdfunding/h5/3_eu.png',
            include: ['Climatiseur portable WAVE 2 x 1', 'Station électrique portable DELTA 2 x 1', 'Câble XT150-1m (connecte WAVE 2 à DELTA 2) x 1'],
            delivery_date: '',
            sale: 0,
            count: null,
            countdown: false,
            discountPrice: 2198,
            originalPrice: 2398,
            price_suffix: '',
            sku: '6900906721353',
            node: 'product-component-1683629871400',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-super-early-bird',
        },

        // EcoFlow WAVE 2 Portable Air Conditioner + DELTA 2 Max
        // {
        //     id: '8443703165275',
        //     variantId: '46778498777435',
        //     type: 1,
        //     stage: 1, // 1 第一个倒计时阶段 2 第二个倒计时阶段
        //     off: '',
        //     offTips: '',
        //     name: 'WAVE 2 + DELTA 2 Max',
        //     tag: 'Offre limitée',
        //     isEnd: false,
        //     img: '/media/wave2/crowdfunding/pc/3_eu.png',
        //     mobileImg: '/media/wave2/crowdfunding/h5/3_eu.png',
        //     include: ['Climatiseur portable WAVE 2 x 1', 'Station électrique portable DELTA 2 Max x 1', 'Câble XT150-1m (connecte WAVE 2 à DELTA 2 Max) x 1'],
        //     delivery_date: '',
        //     sale: 0,
        //     count: null,
        //     countdown: true,
        //     discountPrice: 3298,
        //     originalPrice: 3298,
        //     price_suffix: '',
        //     sku: '46778498777435',
        //     node: 'product-component-1686033361014',
        //     buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-super-early-bird',
        // },

        // EcoFlow WAVE 2 Portable Air Conditioner + DELTA Max
        {
            id: '8420087988571',
            variantId: '46726357188955',
            type: 1,
            stage: 1, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            ignore: true, // 无限库存
            off: '',
            offTips: '',
            name: 'WAVE 2 + DELTA Max',
            tag: 'Offre limitée',
            isEnd: false,
            img: '/media/wave2/crowdfunding/pc/4.png',
            mobileImg: '/media/wave2/crowdfunding/h5/4.png',
            include: ['Climatiseur portable WAVE 2 x 1', 'Station électrique portable DELTA Max 2000 x 1', 'Câble XT150-1m (connecte WAVE 2 à DELTA Max) x 1'],
            delivery_date: '',
            sale: 0,
            count: null,
            countdown: true,
            discountPrice: 2798,
            originalPrice: 3498,
            price_suffix: '',
            sku: '6900906721353',
            node: 'product-component-1683629954277',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
        },
        {
            id: '8420087988571',
            variantId: '46726357188955',
            type: 1,
            stage: 2, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            ignore: true, // 无限库存
            off: '',
            offTips: '',
            name: 'WAVE 2 + DELTA Max',
            tag: null,
            isEnd: false,
            img: '/media/wave2/crowdfunding/pc/4.png',
            mobileImg: '/media/wave2/crowdfunding/h5/4.png',
            include: ['Climatiseur portable WAVE 2 x 1', 'Station électrique portable DELTA Max 2000 x 1', 'Câble XT150-1m (connecte WAVE 2 à DELTA Max) x 1'],
            delivery_date: '',
            sale: 0,
            count: null,
            // countdown: true,
            discountPrice: 2898,
            originalPrice: 3098,
            price_suffix: '',
            sku: '6900906721353',
            node: 'product-component-1683629954277',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
        },
        // {
        //     id: '8443703165275',
        //     variantId: '46778498777435',
        //     type: 1,
        //     stage: 2, // 1 第一个倒计时阶段 2 第二个倒计时阶段
        //     ignore: true, // 无限库存
        //     off: '',
        //     offTips: '',
        //     name: 'WAVE 2 + DELTA 2 Max',
        //     tag: null,
        //     isEnd: false,
        //     img: '/media/wave2/crowdfunding/pc/4_eu.png',
        //     mobileImg: '/media/wave2/crowdfunding/h5/4_eu.png',
        //     include: ['Climatiseur portable WAVE 2 x 1', 'Station électrique portable DELTA 2 Max x 1', 'Câble XT150-1m (connecte WAVE 2 à DELTA 2 Max) x 1'],
        //     delivery_date: '',
        //     sale: 0,
        //     count: null,
        //     countdown: false,
        //     discountPrice: 3298,
        //     originalPrice: 3298,
        //     price_suffix: '',
        //     sku: '46778498777435',
        //     node: 'product-component-1686033361014',
        //     buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-super-early-bird',
        // },
    ],
    it: [
        // 真实数据
        // WAVE 2 Portable Air Conditioner
        {
            id: '8368685220189',
            variantId: '46532250698077',
            type: 1,
            stage: 1, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            ignore: true, // 无限库存
            off: '',
            offTips: '',
            name: "Condizionatore d'aria portatile WAVE 2",
            tag: 'Offerta limitata',
            isEnd: false,
            img: '/media/wave2/crowdfunding/pc/1.png',
            mobileImg: '/media/wave2/crowdfunding/h5/1.png',
            include: ["Condizionatore d'aria portatile WAVE 2 x 1"],
            delivery_date: '',
            sale: 0,
            count: null,
            countdown: true,
            discountPrice: 1099,
            originalPrice: 1199,
            price_suffix: '',
            sku: 'ZYDKT210-US',
            node: 'product-component-1683627341911',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-super-early-bird',
        },
        {
            id: '8368685220189',
            variantId: '46532250698077',
            type: 1,
            stage: 2, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            ignore: true, // 无限库存
            off: '',
            offTips: '',
            name: "Condizionatore d'aria portatile WAVE 2",
            tag: null,
            isEnd: false,
            img: '/media/wave2/crowdfunding/pc/1.png',
            mobileImg: '/media/wave2/crowdfunding/h5/1.png',
            include: ["Condizionatore d'aria portatile WAVE 2 x 1"],
            delivery_date: '',
            sale: 0,
            count: null,
            countdown: false,
            discountPrice: 999,
            originalPrice: 1199,
            price_suffix: '',
            sku: 'ZYDKT210-US',
            node: 'product-component-1683627341911',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-super-early-bird',
        },

        // WAVE 2 Portable Air Conditioner + Add-on Battery
        {
            id: '8368685220189',
            variantId: '46532250665309',
            type: 1,
            stage: 1, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            ignore: true, // 无限库存
            off: '',
            offTips: '',
            name: 'WAVE 2 + batteria supplementare',
            tag: 'Offerta limitata',
            isEnd: false,
            img: '/media/wave2/crowdfunding/pc/2.png',
            mobileImg: '/media/wave2/crowdfunding/h5/2.png',
            include: ["Condizionatore d'aria portatile WAVE 2 x 1", 'Batteria aggiuntiva WAVE 2 x 1'],
            delivery_date: '',
            sale: 0,
            count: null,
            countdown: true,
            discountPrice: 1799,
            originalPrice: 2098,
            price_suffix: '',
            sku: 'WAVE2-EB',
            node: 'product-component-1683627381175',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-super-early-bird',
        },
        {
            id: '8368685220189',
            variantId: '46532250665309',
            type: 1,
            stage: 2, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            ignore: true, // 无限库存
            off: '',
            offTips: '',
            name: 'WAVE 2 + batteria supplementare',
            tag: null,
            isEnd: false,
            img: '/media/wave2/crowdfunding/pc/2.png',
            mobileImg: '/media/wave2/crowdfunding/h5/2.png',
            include: ["Condizionatore d'aria portatile WAVE 2 x 1", 'Batteria aggiuntiva WAVE 2 x 1'],
            delivery_date: '',
            sale: 0,
            count: null,
            countdown: false,
            discountPrice: 1699,
            originalPrice: 1999,
            price_suffix: '',
            sku: 'WAVE2-EB',
            node: 'product-component-1683627381175',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-super-early-bird',
        },

        // EcoFlow WAVE 2 Portable Air Conditioner + DELTA 2
        {
            id: '8381299556701',
            variantId: '46544737501533',
            type: 1,
            stage: 1, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            ignore: true, // 无限库存
            off: '',
            offTips: '',
            name: 'WAVE 2 + DELTA 2',
            tag: 'Offerta limitata',
            isEnd: false,
            img: '/media/wave2/crowdfunding/pc/3_eu.png',
            mobileImg: '/media/wave2/crowdfunding/h5/3_eu.png',
            include: ["Condizionatore d'aria portatile WAVE 2 x 1", 'Power Station Portatile DELTA 2 x 1', 'Cavo XT150-1m (collega WAVE 2 a DELTA 2) x 1'],
            delivery_date: '',
            sale: 0,
            count: null,
            countdown: true,
            discountPrice: 2098,
            originalPrice: 2398,
            price_suffix: '',
            sku: '6900906721353',
            node: 'product-component-1683627407880',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-super-early-bird',
        },
        {
            id: '8381299556701',
            variantId: '46544737501533',
            type: 1,
            stage: 2, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            ignore: true, // 无限库存
            off: '',
            offTips: '',
            name: 'WAVE 2 + DELTA 2',
            tag: null,
            isEnd: false,
            img: '/media/wave2/crowdfunding/pc/3_eu.png',
            mobileImg: '/media/wave2/crowdfunding/h5/3_eu.png',
            include: ["Condizionatore d'aria portatile WAVE 2 x 1", 'Power Station Portatile DELTA 2 x 1', 'Cavo XT150-1m (collega WAVE 2 a DELTA 2) x 1'],
            delivery_date: '',
            sale: 0,
            count: null,
            countdown: false,
            discountPrice: 2198,
            originalPrice: 2398,
            price_suffix: '',
            sku: '6900906721353',
            node: 'product-component-1683627407880',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-super-early-bird',
        },

        // EcoFlow WAVE 2 Portable Air Conditioner + DELTA 2 Max
        // {
        //     id: '8425527673181',
        //     variantId: '46879290425693',
        //     type: 3,
        //     stage: 2, // 1 第一个倒计时阶段 2 第二个倒计时阶段
        //     off: '',
        //     offTips: '',
        //     name: 'WAVE 2 + DELTA 2 Max',
        //     tag: null,
        //     isEnd: false,
        //     img: '/media/wave2/crowdfunding/pc/3_eu.png',
        //     mobileImg: '/media/wave2/crowdfunding/h5/3_eu.png',
        //     include: [
        //         "Condizionatore d'aria portatile WAVE 2 x 1",
        //         'Power Station Portatile DELTA 2 Max x 1',
        //         'Cavo XT150-1m (collega WAVE 2 a DELTA 2 Max) x 1',
        //     ],
        //     delivery_date: '',
        //     sale: 0,
        //     count: null,
        //     discountPrice: 3298,
        //     originalPrice: 3298,
        //     price_suffix: '',
        //     sku: '46879290425693',
        //     node: 'product-component-1686033917264',
        //     buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-super-early-bird',
        // },

        // EcoFlow WAVE 2 Portable Air Conditioner + DELTA Max
        {
            id: '8398855111005',
            variantId: '46668376015197',
            type: 1,
            stage: 1, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            ignore: true, // 无限库存
            off: '',
            offTips: '',
            name: 'WAVE 2 + DELTA Max',
            tag: 'Offerta limitata',
            isEnd: false,
            img: '/media/wave2/crowdfunding/pc/4.png',
            mobileImg: '/media/wave2/crowdfunding/h5/4.png',
            include: ["Condizionatore d'aria portatile WAVE 2", 'Power Station Portatile DELTA Max 2000 x 1', 'Cavo XT150-1m (collega WAVE 2 a DELTA Max) x 1'],
            delivery_date: '',
            sale: 0,
            count: null,
            countdown: true,
            discountPrice: 2798,
            originalPrice: 3498,
            price_suffix: '',
            sku: '6900906721353',
            node: 'product-component-1683627435056',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
        },
        {
            id: '8398855111005',
            variantId: '46668376015197',
            type: 1,
            stage: 2, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            ignore: true, // 无限库存
            off: '',
            offTips: '',
            name: 'WAVE 2 + DELTA Max',
            tag: '',
            isEnd: false,
            img: '/media/wave2/crowdfunding/pc/4.png',
            mobileImg: '/media/wave2/crowdfunding/h5/4.png',
            include: ["Condizionatore d'aria portatile WAVE 2", 'Power Station Portatile DELTA Max 2000 x 1', 'Cavo XT150-1m (collega WAVE 2 a DELTA Max) x 1'],
            delivery_date: '',
            sale: 0,
            count: null,
            // countdown: true,
            discountPrice: 2898,
            originalPrice: 3098,
            price_suffix: '',
            sku: '6900906721353',
            node: 'product-component-1683627435056',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
        },
        // {
        //     id: '8425527673181',
        //     variantId: '46879290425693',
        //     type: 1,
        //     stage: 2, // 1 第一个倒计时阶段 2 第二个倒计时阶段
        //     ignore: true, // 无限库存
        //     off: '',
        //     offTips: '',
        //     name: 'WAVE 2 + DELTA 2 Max',
        //     tag: null,
        //     isEnd: false,
        //     img: '/media/wave2/crowdfunding/pc/4_eu.png',
        //     mobileImg: '/media/wave2/crowdfunding/h5/4_eu.png',
        //     include: [
        //         "Condizionatore d'aria portatile WAVE 2 x 1",
        //         'Power Station Portatile DELTA 2 Max x 1',
        //         'Cavo XT150-1m (collega WAVE 2 a DELTA 2 Max) x 1',
        //     ],
        //     delivery_date: '',
        //     sale: 0,
        //     count: null,
        //     countdown: false,
        //     discountPrice: 3298,
        //     originalPrice: 3298,
        //     price_suffix: '',
        //     sku: '46879290425693',
        //     node: 'product-component-1686033917264',
        //     buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-super-early-bird',
        // },
    ],
    es: [
        // 真实数据
        // WAVE 2 Portable Air Conditioner
        {
            id: '8370477138267',
            variantId: '46505471508827',
            type: 1,
            stage: 1, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            ignore: true, // 无限库存
            off: '',
            offTips: '',
            name: 'Acondicionador de aire portátil WAVE 2 ',
            tag: 'Oferta limitada',
            isEnd: false,
            img: '/media/wave2/crowdfunding/pc/1.png',
            mobileImg: '/media/wave2/crowdfunding/h5/1.png',
            include: ['Acondicionador de aire portátil WAVE 2 x 1'],
            delivery_date: '',
            sale: 0,
            count: null,
            countdown: true,
            discountPrice: 1099,
            originalPrice: 1199,
            price_suffix: '',
            sku: 'ZYDKT210-US',
            node: 'product-component-1683626314065',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-super-early-bird',
        },
        {
            id: '8370477138267',
            variantId: '46505471508827',
            type: 1,
            stage: 2, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            ignore: true, // 无限库存
            off: '',
            offTips: '',
            name: 'Acondicionador de aire portátil WAVE 2 ',
            tag: null,
            isEnd: false,
            img: '/media/wave2/crowdfunding/pc/1.png',
            mobileImg: '/media/wave2/crowdfunding/h5/1.png',
            include: ['Acondicionador de aire portátil WAVE 2 x 1'],
            delivery_date: '',
            sale: 0,
            count: null,
            countdown: false,
            discountPrice: 999,
            originalPrice: 1199,
            price_suffix: '',
            sku: 'ZYDKT210-US',
            node: 'product-component-1683626314065',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-super-early-bird',
        },

        // WAVE 2 Portable Air Conditioner + Add-on Battery
        {
            id: '8370477138267',
            variantId: '46505471476059',
            type: 1,
            stage: 1, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            ignore: true, // 无限库存
            off: '',
            offTips: '',
            name: 'WAVE 2  + batería adicional',
            tag: 'Oferta limitada',
            isEnd: false,
            img: '/media/wave2/crowdfunding/pc/2.png',
            mobileImg: '/media/wave2/crowdfunding/h5/2.png',
            include: ['Acondicionador de aire portátil WAVE 2 x 1', 'Batería adicional EcoFlow WAVE 2 x 1'],
            delivery_date: '',
            sale: 0,
            count: null,
            countdown: true,
            discountPrice: 1799,
            originalPrice: 2098,
            price_suffix: '',
            sku: 'WAVE2-EB',
            node: 'product-component-1683626385275',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-super-early-bird',
        },
        {
            id: '8370477138267',
            variantId: '46505471476059',
            type: 1,
            stage: 2, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            ignore: true, // 无限库存
            off: '',
            offTips: '',
            name: 'WAVE 2  + batería adicional',
            tag: null,
            isEnd: false,
            img: '/media/wave2/crowdfunding/pc/2.png',
            mobileImg: '/media/wave2/crowdfunding/h5/2.png',
            include: ['Acondicionador de aire portátil WAVE 2 x 1', 'Batería adicional EcoFlow WAVE 2 x 1'],
            delivery_date: '',
            sale: 0,
            count: null,
            countdown: false,
            discountPrice: 1699,
            originalPrice: 1999,
            price_suffix: '',
            sku: 'WAVE2-EB',
            node: 'product-component-1683626385275',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-super-early-bird',
        },

        // EcoFlow WAVE 2 Portable Air Conditioner + DELTA 2
        {
            id: '8378588594523',
            variantId: '46674132369755',
            type: 1,
            stage: 1, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            ignore: true, // 无限库存
            off: '',
            offTips: '',
            name: 'WAVE 2  + DELTA 2',
            tag: 'Oferta limitada',
            isEnd: false,
            img: '/media/wave2/crowdfunding/pc/3_eu.png',
            mobileImg: '/media/wave2/crowdfunding/h5/3_eu.png',
            include: [
                'Acondicionador de aire portátil WAVE 2 x 1',
                'Estación de Energía Portátil DELTA 2 x 1',
                'Cable XT150-1m (conecta WAVE 2 a DELTA 2) x 1',
            ],
            delivery_date: '',
            sale: 0,
            count: null,
            countdown: true,
            discountPrice: 2098,
            originalPrice: 2398,
            price_suffix: '',
            sku: '6900906721353',
            node: 'product-component-1683627035713',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-super-early-bird',
        },
        {
            id: '8378588594523',
            variantId: '46674132369755',
            type: 1,
            stage: 2, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            ignore: true, // 无限库存
            off: '',
            offTips: '',
            name: 'WAVE 2  + DELTA 2',
            tag: null,
            isEnd: false,
            img: '/media/wave2/crowdfunding/pc/3_eu.png',
            mobileImg: '/media/wave2/crowdfunding/h5/3_eu.png',
            include: [
                'Acondicionador de aire portátil WAVE 2 x 1',
                'Estación de Energía Portátil DELTA 2 x 1',
                'Cable XT150-1m (conecta WAVE 2 a DELTA 2) x 1',
            ],
            delivery_date: '',
            sale: 0,
            count: null,
            countdown: false,
            discountPrice: 2198,
            originalPrice: 2398,
            price_suffix: '',
            sku: '6900906721353',
            node: 'product-component-1683627035713',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-super-early-bird',
        },

        // EcoFlow WAVE 2 Portable Air Conditioner + DELTA 2 Max
        // {
        //     id: '8446401151323',
        //     variantId: '46784663159131',
        //     type: 1,
        //     stage: 1, // 1 第一个倒计时阶段 2 第二个倒计时阶段
        //     off: '',
        //     offTips: '',
        //     name: 'WAVE 2  + DELTA 2 Max',
        //     tag: null,
        //     isEnd: false,
        //     img: '/media/wave2/crowdfunding/pc/3_eu.png',
        //     mobileImg: '/media/wave2/crowdfunding/h5/3_eu.png',
        //     include: [
        //         'Acondicionador de aire portátil WAVE 2 x 1',
        //         'Estación de Energía Portátil DELTA 2 Max x 1',
        //         'Cable XT150-1m (conecta WAVE 2 a DELTA 2 Max) x 1',
        //     ],
        //     delivery_date: '',
        //     sale: 0,
        //     count: null,
        //     discountPrice: 3298,
        //     originalPrice: 3298,
        //     price_suffix: '',
        //     sku: '46784663159131',
        //     node: 'product-component-1686034020763',
        //     buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-super-early-bird',
        // },

        // EcoFlow WAVE 2 Portable Air Conditioner + DELTA Max
        {
            id: '8420093624667',
            variantId: '46726372524379',
            type: 1,
            stage: 1, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            ignore: true, // 无限库存
            off: '',
            offTips: '',
            name: 'WAVE 2  + DELTA Max',
            tag: 'Oferta limitada',
            isEnd: false,
            img: '/media/wave2/crowdfunding/pc/4.png',
            mobileImg: '/media/wave2/crowdfunding/h5/4.png',
            include: [
                'Acondicionador de aire portátil WAVE 2',
                'Estación de Energía Portátil ELTA Max 2000',
                'Cable XT150-1m (conecta WAVE 2 a DELTA Max) x 1',
            ],
            delivery_date: '',
            sale: 0,
            count: null,
            countdown: true,
            discountPrice: 2798,
            originalPrice: 3498,
            price_suffix: '',
            sku: '6900906721353',
            node: 'product-component-1683627095074',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
        },
        {
            id: '8420093624667',
            variantId: '46726372524379',
            type: 1,
            stage: 2, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            ignore: true, // 无限库存
            off: '',
            offTips: '',
            name: 'WAVE 2  + DELTA Max',
            tag: null,
            isEnd: false,
            img: '/media/wave2/crowdfunding/pc/4.png',
            mobileImg: '/media/wave2/crowdfunding/h5/4.png',
            include: [
                'Acondicionador de aire portátil WAVE 2',
                'Estación de Energía Portátil ELTA Max 2000',
                'Cable XT150-1m (conecta WAVE 2 a DELTA Max) x 1',
            ],
            delivery_date: '',
            sale: 0,
            count: null,
            // countdown: true,
            discountPrice: 2898,
            originalPrice: 3098,
            price_suffix: '',
            sku: '6900906721353',
            node: 'product-component-1683627095074',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
        },
        // {
        //     id: '8446401151323',
        //     variantId: '46784663159131',
        //     type: 1,
        //     stage: 2, // 1 第一个倒计时阶段 2 第二个倒计时阶段
        //     ignore: true, // 无限库存
        //     off: '',
        //     offTips: '',
        //     name: 'WAVE 2  + DELTA 2 Max',
        //     tag: null,
        //     isEnd: false,
        //     img: '/media/wave2/crowdfunding/pc/3_eu.png',
        //     mobileImg: '/media/wave2/crowdfunding/h5/3_eu.png',
        //     include: [
        //         'Acondicionador de aire portátil WAVE 2 x 1',
        //         'Estación de Energía Portátil DELTA 2 Max x 1',
        //         'Cable XT150-1m (conecta WAVE 2 a DELTA 2 Max) x 1',
        //     ],
        //     delivery_date: '',
        //     sale: 0,
        //     count: null,
        //     countdown: false,
        //     discountPrice: 3298,
        //     originalPrice: 3298,
        //     price_suffix: '',
        //     sku: '46784663159131',
        //     node: 'product-component-1686034020763',
        //     buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-super-early-bird',
        // },
    ],
    // 2024年4月重新售卖早鸟 US/CA
    us: [
        // EcoFlow WAVE 2 + Add-on Battery
        {
            id: '7064125210697',
            variantId: '41106590892105',
            type: 3, //1 时间限定 2 数量限定 3 只有一个常规售卖阶段
            stage: 2, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            off: '',
            offTips: '',
            name: 'EcoFlow WAVE 2 + Add-on Battery',
            tag: 'PRIME DEAL',
            isEnd: false,
            img: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1719037008935/EcoFlow%20WAVE%202%20%2B%20Add-on%20Battery%20%2B%20Car%20Vent%20Kit.png',
            mobileImg:
                'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1719037235758/EcoFlow%20WAVE%202%20%2B%20Add-on%20Battery%20%2B%20Car%20Vent%20Kit.png',
            include: ['EcoFlow WAVE 2 Portable Air Conditioner', 'Add-on Battery'],
            // delivery_date:
            //     'The EcoFlow WAVE 2 will be shipped separately in early July.\nThe WAVE 2 Add-On Battery will be shipped separately from early July.',
            delivery_date: '',
            sale: 0,
            count: 200,
            realCount: 600,
            discountPrice: 999,
            originalPrice: 1299,
            price_suffix: '',
            sku: 'WAVE2-EB',
            node: 'product-component-1712491493037',
            buyLink: 'https://us.ecoflow.com/products/wave-2-portable-air-conditioner',
            link_more: 'https://us.ecoflow.com/products/wave-2-portable-air-conditioner?variant=41106590892105',
        },
        // EcoFlow WAVE 2 + DELTA Pro
        {
            id: '7064125210697',
            variantId: '41106590957641',
            type: 3, //1 时间限定 2 数量限定 3 只有一个常规售卖阶段
            stage: 2, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            off: '',
            offTips: '',
            name: 'EcoFlow WAVE 2 + DELTA Pro',
            tag: 'PRIME DEAL',
            isEnd: false,
            img: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1719037073469/EcoFlow%20WAVE%202%20%2B%20DELTA%20Pro%20%2B%20Adapter%20%2B%20Car%20Vent%20Kit.png',
            mobileImg:
                'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1719037255740/EcoFlow%20WAVE%202%20%2B%20DELTA%20Pro%20%2B%20Adapter%20%2B%20Car%20Vent%20Kit.png',
            include: [
                'EcoFlow WAVE 2 Portable Air Conditioner',
                'EcoFlow DELTA Pro',
                'EcoFlow DELTA Pro to Smart Generator Adapter',
                'EcoFlow Extra Battery Cable (1m)',
            ],
            // delivery_date: 'The EcoFlow WAVE 2 will be shipped separately in early July.',
            delivery_date: '',
            sale: 0,
            count: 200,
            realCount: 600,
            discountPrice: 1599,
            originalPrice: 2099,
            price_suffix: '',
            sku: '',
            node: 'product-component-1712491581765',
            buyLink: 'https://us.ecoflow.com/products/wave-2-portable-air-conditioner',
            link_more: 'https://us.ecoflow.com/products/wave-2-portable-air-conditioner?variant=41106590957641',
        },
        // EcoFlow WAVE 2 + Add-on Battery + 800W Alternator Charger
        {
            id: '7064125210697',
            variantId: '41106590924873',
            type: 3, //1 时间限定 2 数量限定 3 只有一个常规售卖阶段
            stage: 2, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            off: '',
            offTips: '',
            name: 'EcoFlow WAVE 2 + Add-on Battery + 800W Alternator Charger',
            tag: 'PRIME DEAL',
            isEnd: false,
            img: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1719037111837/EcoFlow%20WAVE%202%20%2B%20Add-on%20Battery%20%2B%20800W%20Alternator%20Charger%20%2B%20Car%20Vent%20Kit.png',
            mobileImg:
                'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1719037272104/EcoFlow%20WAVE%202%20%2B%20Add-on%20Battery%20%2B%20800W%20Alternator%20Charger%20%2B%20Car%20Vent%20Kit.png',
            include: ['EcoFlow WAVE 2 Portable Air Conditioner', 'Add-on Battery', 'EcoFlow 800W Alternator Charger'],
            // delivery_date:
            //     'The EcoFlow WAVE 2 will be shipped separately in early July.\nThe WAVE 2 Add-On Battery will be shipped separately from early July.',
            delivery_date: '',
            sale: 0,
            count: 200,
            realCount: 600,
            discountPrice: 1099,
            originalPrice: 1399,
            price_suffix: '',
            sku: '',
            node: 'product-component-1712491537602',
            buyLink: 'https://us.ecoflow.com/products/wave-2-portable-air-conditioner',
            link_more: 'https://us.ecoflow.com/products/wave-2-portable-air-conditioner?variant=41106590924873',
        },
        // EEcoFlow WAVE 2 + DELTA 2 Max
        {
            id: '7064125210697',
            variantId: '41106614976585',
            type: 3, //1 时间限定 2 数量限定 3 只有一个常规售卖阶段
            stage: 2, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            off: '',
            offTips: '',
            name: 'EcoFlow WAVE 2 + DELTA 2 Max',
            tag: 'PRIME DEAL',
            isEnd: false,
            img: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1719037131671/EcoFlow%20WAVE%202%20%2B%20DELTA%202%20Max%20%20%2B%20Car%20Vent%20Kit.png',
            mobileImg:
                'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1719037289091/EcoFlow%20WAVE%202%20%2B%20DELTA%202%20Max%20%20%2B%20Car%20Vent%20Kit.png',
            include: ['EcoFlow WAVE 2 Portable Air Conditioner', 'EcoFlow DELTA 2 Max'],
            // delivery_date: 'The EcoFlow WAVE 2 will be shipped separately in early July.',
            delivery_date: '',
            sale: 0,
            count: 200,
            realCount: 600,
            discountPrice: 1699,
            originalPrice: 2299,
            price_suffix: '',
            sku: '',
            node: 'product-component-1712491599653',
            buyLink: 'https://us.ecoflow.com/products/wave-2-portable-air-conditioner',
            link_more: 'https://us.ecoflow.com/products/wave-2-portable-air-conditioner?variant=41106614976585',
        },
        // EcoFlow WAVE 2
        {
            id: '7064125210697',
            variantId: '41106590990409',
            type: 3, //1 时间限定 2 数量限定 3 只有一个常规售卖阶段
            stage: 2, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            off: '',
            offTips: '',
            name: 'EcoFlow WAVE 2',
            tag: 'PRIME DEAL',
            isEnd: false,
            img: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1719037170721/EcoFlow%20WAVE%202%20%2B%20Car%20Vent%20Kit.png',
            mobileImg: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1719037313420/EcoFlow%20WAVE%202%20%2B%20Car%20Vent%20Kit.png',
            include: ['EcoFlow WAVE 2 Portable Air Conditioner'],
            delivery_date: 'The EcoFlow WAVE 2 will be shipped separately in early July.',
            sale: 0,
            count: 200,
            realCount: 600,
            discountPrice: 1199,
            originalPrice: 1299,
            price_suffix: '',
            sku: '',
            node: 'product-component-1712491623118',
            buyLink: 'https://us.ecoflow.com/products/wave-2-portable-air-conditioner',
            link_more: 'https://us.ecoflow.com/products/wave-2-portable-air-conditioner?variant=41106590990409',
        },
        // EcoFlow 800W Alternator Charger
        {
            id: '7049853632585',
            variantId: '41064248836169',
            type: 3, //1 时间限定 2 数量限定 3 只有一个常规售卖阶段
            stage: 2, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            off: '',
            offTips: '',
            name: 'EcoFlow 800W Alternator Charger',
            tag: 'PRIME DEAL',
            isEnd: false,
            img: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1719211816760/EcoFlow%20800W%20Alternator%20Charger.png',
            mobileImg: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1719211816760/EcoFlow%20800W%20Alternator%20Charger.png',
            include: ['EcoFlow 800W Alternator Charger'],
            delivery_date: '',
            sale: 0,
            count: 200,
            realCount: 600,
            discountPrice: 699,
            originalPrice: 799,
            price_suffix: '',
            sku: '',
            node: 'product-component-1712491702352',
            buyLink: 'https://us.ecoflow.com/products/800w-alternator-charger',
            link_more: 'https://us.ecoflow.com/products/800w-alternator-charger?variant=41064248836169',
        },
    ],
    ca: [
        // EcoFlow WAVE 2 + Add-on Battery
        {
            id: '8130581463194',
            variantId: '44674797240474',
            type: 3, //1 时间限定 2 数量限定 3 只有一个常规售卖阶段
            stage: 2, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            off: '',
            offTips: '',
            name: 'EcoFlow WAVE 2 + Add-on Battery',
            tag: 'PRIME DEAL',
            isEnd: false,
            img: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1719211457360/EcoFlow%20WAVE%202%20%2B%20Add-on%20Battery%20%2B%20Car%20Vent%20Kit.png',
            mobileImg:
                'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1719037637263/EcoFlow%20WAVE%202%20%2B%20Add-on%20Battery%20%2B%20Car%20Vent%20Kit.png',
            include: ['EcoFlow WAVE 2 Portable Air Conditioner', 'Add-on Battery'],
            delivery_date: '',
            sale: 0,
            count: 200,
            // realCount: 600,
            discountPrice: 999,
            originalPrice: 1299,
            price_suffix: '',
            sku: 'WAVE2-EB',
            node: 'product-component-1712492418367',
            buyLink: 'https://ca.ecoflow.com/products/wave-2-portable-air-conditioner',
            link_more: 'https://ca.ecoflow.com/products/wave-2-portable-air-conditioner?variant=44674797240474',
        },
        // EcoFlow WAVE 2 + DELTA Pro
        {
            id: '8130581463194',
            variantId: '44674825781402',
            type: 3, //1 时间限定 2 数量限定 3 只有一个常规售卖阶段
            stage: 2, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            off: '',
            offTips: '',
            name: 'EcoFlow WAVE 2 + DELTA Pro',
            tag: 'PRIME DEAL',
            isEnd: false,
            img: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1719211508744/EcoFlow%20WAVE%202%20%2B%20DELTA%20Pro%20%2B%20Adapter%20%2B%20Car%20Vent%20Kit.png',
            mobileImg:
                'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1719037681548/EcoFlow%20WAVE%202%20%2B%20DELTA%20Pro%20%2B%20Adapter%20%2B%20Car%20Vent%20Kit.png',
            include: [
                'EcoFlow WAVE 2 Portable Air Conditioner',
                'EcoFlow DELTA Pro',
                'EcoFlow DELTA Pro to Smart Generator Adapter',
                'EcoFlow Extra Battery Cable (1m)',
            ],
            delivery_date: '',
            sale: 0,
            count: 200,
            // realCount: 600,
            discountPrice: 1099,
            originalPrice: 1399,
            price_suffix: '',
            sku: '',
            node: 'product-component-1712492463386',
            buyLink: 'https://ca.ecoflow.com/products/wave-2-portable-air-conditioner',
            link_more: 'https://ca.ecoflow.com/products/wave-2-portable-air-conditioner?variant=44674825781402',
        },
        // EcoFlow WAVE 2 + DELTA 2 Max
        {
            id: '8130581463194',
            variantId: '44674825814170',
            type: 3, //1 时间限定 2 数量限定 3 只有一个常规售卖阶段
            stage: 2, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            off: '',
            offTips: '',
            name: 'EcoFlow WAVE 2 + DELTA 2 Max',
            tag: 'PRIME DEAL',
            isEnd: false,
            img: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1719211549291/EcoFlow%20WAVE%202%20%2B%20DELTA%202%20Max%20%20%2B%20Car%20Vent%20Kit.png',
            mobileImg:
                'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1719037709546/EcoFlow%20WAVE%202%20%2B%20DELTA%202%20Max%20%20%2B%20Car%20Vent%20Kit.png',
            include: ['EcoFlow WAVE 2 Portable Air Conditioner', 'EcoFlow DELTA 2 Max'],
            delivery_date: '',
            sale: 0,
            count: 200,
            // realCount: 600,
            discountPrice: 1699,
            originalPrice: 2299,
            price_suffix: '',
            sku: '',
            node: 'product-component-1712491599653',
            buyLink: 'https://ca.ecoflow.com/products/wave-2-portable-air-conditioner',
            link_more: 'https://ca.ecoflow.com/products/wave-2-portable-air-conditioner?variant=44674825814170',
        },
        // EcoFlow WAVE 2
        {
            id: '8130581463194',
            variantId: '44674825879706',
            type: 3, //1 时间限定 2 数量限定 3 只有一个常规售卖阶段
            stage: 2, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            off: '',
            offTips: '',
            name: 'EcoFlow WAVE 2',
            tag: 'PRIME DEAL',
            isEnd: false,
            img: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1719211601411/EcoFlow%20WAVE%202%20%2B%20Car%20Vent%20Kit.png',
            mobileImg: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1719037723624/EcoFlow%20WAVE%202%20%2B%20Car%20Vent%20Kit.png',
            include: ['EcoFlow WAVE 2 Portable Air Conditioner'],
            delivery_date: '',
            sale: 0,
            count: 200,
            // realCount: 600,
            discountPrice: 1199,
            originalPrice: 1299,
            price_suffix: '',
            sku: '',
            node: 'product-component-1712492534736',
            buyLink: 'https://ca.ecoflow.com/products/wave-2-portable-air-conditioner',
            link_more: 'https://ca.ecoflow.com/products/wave-2-portable-air-conditioner?variant=44674825879706',
        },
    ],

    ph: [
        // 真实数据
        // WAVE 2 Portable Air Conditioner
        {
            id: '9451911414070',
            variantId: '49117748494646',
            type: 1, // type 1: 时间限定 2: 库存限定 3: 仅有一个时间阶段无限库存
            stage: 1, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            ignore: true, // 无限库存
            off: '',
            offTips: '',
            name: 'WAVE 2 Portable Air Conditioner',
            tag: 'Limited Offer',
            isEnd: false,
            img: '/media/wave2/crowdfunding/pc/1.png',
            mobileImg: '/media/wave2/crowdfunding/h5/1.png',
            include: ['WAVE 2 Portable Air Conditioner x 1'],
            delivery_date: '',
            sale: 0,
            count: null,
            countdown: false,
            price_suffix: '',
            sku: 'ZYDKT210-US',
            node: 'product-component-1683628221331',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-super-early-bird',
        },
        {
            id: '9451911414070',
            variantId: '49117748494646',
            type: 1, // type 1: 库存限定 2: 时间限定 3: 仅有一个时间阶段无限库存
            stage: 2, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            ignore: true, // 无限库存
            off: '',
            offTips: '',
            name: 'WAVE 2 Portable Air Conditioner',
            tag: null,
            isEnd: false,
            img: '/media/wave2/crowdfunding/pc/1.png',
            mobileImg: '/media/wave2/crowdfunding/h5/1.png',
            include: ['WAVE 2 Portable Air Conditioner x 1'],
            delivery_date: '',
            sale: 0,
            count: null,
            countdown: false,
            price_suffix: '',
            sku: 'ZYDKT210-US',
            node: 'product-component-1683628221331',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-super-early-bird',
        },

        // WAVE 2+ Plug-in Battery
        {
            id: '9451911414070',
            variantId: '49117748527414',
            type: 1,
            stage: 1, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            ignore: true, // 无限库存
            off: '',
            offTips: '',
            name: 'WAVE 2 + Plug-in Battery',
            tag: 'Limited Offer',
            isEnd: false,
            img: '/media/wave2/crowdfunding/pc/2.png',
            mobileImg: '/media/wave2/crowdfunding/h5/2.png',
            include: ['WAVE 2 Portable Air Conditioner x 1', 'WAVE 2 Plug-in Battery x 1'],
            delivery_date: '',
            sale: 0,
            count: null,
            countdown: false,
            price_suffix: '',
            sku: 'WAVE2-EB',
            node: 'product-component-1683629772676',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-super-early-bird',
        },
        {
            id: '9451911414070',
            variantId: '49117748527414',
            type: 1,
            stage: 2, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            ignore: true, // 无限库存
            off: '',
            offTips: '',
            name: 'WAVE 2 + Plug-in Battery',
            tag: null,
            isEnd: false,
            img: '/media/wave2/crowdfunding/pc/2.png',
            mobileImg: '/media/wave2/crowdfunding/h5/2.png',
            include: ['WAVE 2 Portable Air Conditioner x 1', 'WAVE 2 Plug-in Battery x 1'],
            delivery_date: '',
            sale: 0,
            count: null,
            countdown: false,
            price_suffix: '',
            sku: 'WAVE2-EB',
            node: 'product-component-1683629772676',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-super-early-bird',
        },
    ],
};
